import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { ChangeUsersService } from "../../../app/services/change-users.service";
import { HttpClient, HttpResponse, HttpEventType } from "@angular/common/http";
import { Subscription } from "rxjs-compat/Subscription";
import { FileUploader } from "ng2-file-upload";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { FileUploadModule } from 'ng2-file-upload';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import {
  FormGroup,
  FormControl,
  FormArray,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { v4 as uuid } from "uuid";
import { retry } from "rxjs-compat/operator/retry";
import { Subject } from "rxjs";
import { C } from "@angular/cdk/keycodes";
import { CommonModule, DatePipe } from "@angular/common";
import moment from "moment";
// import { validateBasis } from "@angular/flex-layout";
import * as $ from "jquery";
import { MatRadioModule } from '@angular/material/radio'
import { FormsModule } from "@angular/forms";
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteModule, MatOptgroup, MatOption } from "@angular/material/autocomplete";
import { CdkDropListGroup } from "@angular/cdk/drag-drop";
import { MatIconModule } from "@angular/material/icon";
import { DeviceTemplateComponent } from "../../device-template/device-template.component";
import { MatButtonModule } from "@angular/material/button";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-client-add-assets",
  templateUrl: "./client-add-assets.component.html",
  styleUrls: ["./client-add-assets.component.scss"],
  standalone:true,
  imports:[MatRadioModule,FormsModule,NgxSpinnerModule,CommonModule,ReactiveFormsModule,MatAutocomplete,MatOption,MatAutocompleteModule,MatIconModule,DeviceTemplateComponent, MatButtonModule,NgbPopover, FileUploadModule],
  providers: [{ provide: DatePipe, useValue: new DatePipe('en-US') },FormControl],
})
export class ClientAddAssetsComponent implements OnInit {
  parentModel: any;
  @ViewChild("divToScroll") divToScroll: ElementRef;
  tempValue: any;
  assetName: any;
  siteID: any;
  selectedDropDownElement: any = 1;
  applicationNewID: any;
  public devicetosend: any;
  public options: any;
  public pic: any = false;
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + "uploads/";
  public addAssetsUrl = BaseUrlConstantsService.ADD_ASSETS;
  public assetsBearingUrl = BaseUrlConstantsService.ASSETS_BEARING;
  public clientDeviceUrl = BaseUrlConstantsService.CLIENT_DEVICES;
  public allSitesUrl = BaseUrlConstantsService.GET_SITES;
  public middleware_url = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
  public deviceStatusURL = BaseUrlConstantsService.INVENTORY_URL;
  public createBearingNumber = BaseUrlConstantsService.ASSETS_CREATE_BEARING;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public deviceTypeUrl = BaseUrlConstantsService.DEVICE_TYPE;
  public imageAssetUploadUrl = BaseUrlConstantsService.ASSET_IMAGE_UPLOAD;
  public imageUpdateInfoUrl = BaseUrlConstantsService.UPDATE_IMAGE_INFO;
  public assetsUrl = BaseUrlConstantsService.ASSETS_DATA;
  public assetsUrlEdit = BaseUrlConstantsService.ASSETS_DATA_EDIT;
  public updateAssetsUrl = BaseUrlConstantsService.UPDATE_ASSETS;
  public eboilerSitesUrl = BaseUrlConstantsService.eBoilerRoomApi;
  public odrValueHigh: any;
  public cloudPushRateAnomaly: any;
  public cloudAnomalyCounter: any;
  public cloudPushrateHigh: any;
  public scanRateValue: any;
  public temp: any;
  public invalidFrequencyValue: boolean;
  public filterdOptions = [];
  public selectedTemplateView: any = [];
  public assetTemplateID: any;
  public ivInventoryMsg: any = "";
  public preDeBearingNumber: any;
  public atApplicationName: string = "";
  public atSiteName: string = "";
  public inputFiledChanges: any = [];
  public preNdeBearingNumber: any;
  public applicationID: any;
  public existedInventoryID: any;
  public serialNumber: any;
  public templateCollection: any = [];
  public isItAccelroDevice: boolean;
  public currentFormCount: any = 0;
  public datafreq: any = "";
  public odrValue: string = "";
  public inputFieldLength: any = [];
  public connectedMacAddress: any;
  public uploader: FileUploader;
  public variableRPMToggle: string = "fixed";
  public connectionInputProxy: boolean;
  public imagePath;
  public imgURL: any;
  public passwordSsid: any = "";
  public callMqttEnable: boolean = false;
  public isTextFieldType: boolean = false;
  public bearingNumbers: any = [];
  public GMFvisible = false;
  public message: string;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public mx_txt_msg: string = "";
  public pid: any;
  public showList: boolean;
  public emptyMsg: boolean;
  public pageRouteRef: string;
  public lastPageRef: string;
  public fromDataArray: any = [];
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public showSavebtn: boolean;
  public ENV_TYPE: string;
  public deviceTypeID: any;
  public uForm: any;
  public allDevices: any;
  public fromCounter: number = 0;
  public sitesList: any;
  public groupList: any;
  public ssidUser: any = "";
  public ratedPower: any = "";
  public selectedSiteID: any;
  public InventoryIDValue: any = "";
  public siteIDEditCase: any;
  public insertClass = ["A", "B", "F", "H"];
  public noofasset: any;
  public AdvanceSetting: any;
  public count: any = 0;
  public insertClassWinding = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
  ];
  public assetsID: any;
   public assetOrientation: string = "vertical";
  public percentDone = 0;
  public mac_address: any;
  public uploadSuccess: boolean;
  public fileName = "";
  public url: any;
  public userId: any;
  public assetMasterInfo: any = {};
  public today: any;
  public myDate: any;
  public id: any;
  public insulation: any;
  public updateDataReq: any = false;
  public showCancelBtn: boolean;
  public _imgUrl: any;
  public _varYes: any;
  public showEnabledSaveBtn = true;
  public preValueApplication: any;
  public showDisabledSaveBtn: boolean;
  public showEnableUpdateBtn: boolean;
  public showDisabledUpdateBtn: boolean;
  public _imageId = null;
  public connectionInput: boolean = true;
  public userID: any;
  public tempValuesArr: any = [];
  public beltLength: any;
  public editable: boolean = false;
  public driveVisibility: boolean;
  public assetDetailForm: boolean;
  public gearDetailForm: boolean;
  public selectedAssetType: string = "MOTOR";
  public subAssetType: string = "";
  public dcmotor: boolean = false;
  public gmflength: any;
  public driveType: string = "DIRECT";
  public adminID: any;
  public isDisabled: boolean = false;
  public beltData: any = [];
  public onOffStatus: string = "";
  public functionDelay;
  public label: any;
  public device_sno: number = 1;
  public checker: any = 0;
  public overall_powertrain_status=null;
  public overallStatus=null;
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "Assets",
    },
    {
      page_ref: "#",
      page_title: "Create Asset",
    },
  ];
  public stateRef: string = "";
  public templatesList: any = [];
  public tempSList: any = [
    { id: 1, color: "", status: false },
    { id: 2, color: "", status: false },
    { id: 3, color: "", status: false },
    { id: 4, color: "", status: false },
    { id: 5, color: "", status: false },
  ];
  public noOfAssetsOnOne = [1, 2];
  public noOfAssetsOnTwo = [1, 2, 3];
  public noOfAssetsOnThree = [1, 2, 3, 4];
  public assetStatus: number = 1;
  routeState: { [k: string]: any };
  data: { [k: string]: any };

  public deviceCount: number = 0;
  public sensorDetails: any;
  public currentLbl = 1;
  public sensorType = "";
  public createAssetEnabled = true;
  public device: any;
  /** Child event handler and listener */
  public eventsSubject: Subject<void> = new Subject<void>();

  removefirsttime: boolean = true;
  machinethresholdvalue: any;
  deviceid: any;
  assetid: any;
  assetType: any;
  noofsensors: any;
  noofchildren: any;
  VibrationValuesArr: any;
  olddata: any;
  lastCalibrationDate: string;
  public valuebearing: any = "on";
  public outputbearingVal: any = "yes";
  public outerdisabled: boolean;
  public firmware_version: string = null;
  public fromboiler: any;
  public subsystemId: string;
  public getSite: string;
  public boilerName: string = "";
  public applicationName: string = "";
  public siteName: string = "";
  public boiler_application_name: string = "";
  public boiler_site_name: string = "";
  public firmware_version_check: boolean;
  current_firmware_version: any;
  public role: string = localStorage.getItem("role");
  childBtnClickHandler(valueEmitter: any) {
    this.selectedAssetType = valueEmitter.device;
    if (this.selectedAssetType === "MOTOR") {
      this.subAssetType = valueEmitter.subDevice;
      if (this.subAssetType === "DC_MOTOR") {
        this.dcmotor = true;
        this.uForm.get("line_frequency").disable();
      }
    } else {
      this.subAssetType = valueEmitter.device;
    }
    this.sensorDetails = valueEmitter;
    this.currentLbl = this.sensorDetails.sensorDetails.label;
    this.sensorType = this.setLabelForSensors(this.sensorDetails.sensor);
    this.onAssetChangeValue(this.selectedAssetType, "event_change");
  }
  //
  eventHandler(data: any) {
    switch (data.action) {
      case "loaded":
        this.fromCounter = this.deviceCount = data.value;
        this.createAssetEnabled = this.deviceCount == 1 ? true : false;
        break;
      case "sensor_update":
        break;
    }
  }
  nextSensor(
    currentId: number,
    nextId: number,
    asset_id: number,
    mac_address: string
  ) {
    const sensorRaw = this.parentModel;
    let sensorP = sensorRaw.primary.sensors;
    Object.keys(sensorP).forEach((sensorKey) => {
      if (parseInt(sensorP[sensorKey]["label"]) === currentId) {
        sensorP[sensorKey]["id"] = asset_id;
        sensorP[sensorKey]["mac_address"] = mac_address;
      } else if (parseInt(sensorP[sensorKey]["label"]) === nextId) {
        this.selectedAssetType = sensorRaw.primary.device;
        this.currentLbl = nextId;
        this.sensorType = this.setLabelForSensors(sensorKey);
        this.sensorDetails = {
          id: "",
          device: this.selectedAssetType,
          parent: "primary",
          sensor: sensorKey,
          sensorDetails: sensorP[sensorKey],
        };
        this.onAssetChangeValue(this.selectedAssetType, "event_change");

        this.spinner.show();
        let self = this;
        self.gotoTop();
        setTimeout(() => {
          self.resetMotorInputFields();
          self.spinner.hide();
        }, 2000);
        return;
      }
    });
    if (sensorRaw.secondary.device !== "") {
      let sensorS = sensorRaw.secondary.sensors;
      Object.keys(sensorS).forEach((sensorKey) => {
        if (parseInt(sensorS[sensorKey]["label"]) === currentId) {
          sensorS[sensorKey]["id"] = asset_id;
          sensorS[sensorKey]["mac_address"] = mac_address;
        } else if (parseInt(sensorS[sensorKey]["label"]) === nextId) {
          this.selectedAssetType = sensorRaw.secondary.device;
          this.currentLbl = nextId;
          this.sensorType = this.setLabelForSensors(sensorKey);

          this.sensorDetails = {
            id: "",
            device: this.selectedAssetType,
            parent: "secondry",
            sensor: sensorKey,
            sensorDetails: sensorS[sensorKey],
          };
          this.onAssetChangeValue(this.selectedAssetType, "event_change");
          //
          this.spinner.show();
          let self = this;
          self.gotoTop();
          setTimeout(() => {
            self.resetMotorInputFields();
            self.spinner.hide();
          }, 2000);
          return;
        }
      });
    }
    if (this.fromCounter <= nextId) {
      this.createAssetEnabled = true;
    }
  }
  /** End Block Child event handler and listener */

  setLabelForSensors(sensorType) {
    let name;
    switch (sensorType) {
      case "couple":
        name = "OnCoupling";
        break;
      case "de":
        name = "Drive-End";
        break;
      case "nde":
        name = "NonDrive-End";
        break;
      case "frame":
        name = "Frame";
        break;
    }
    return name;
  }

  constructor(
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private service: BackendApiService,
    private http: HttpClient,
    private changeService: ChangeUsersService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state;
    this.assetOrientation = state['orientation'] || 'vertical';
    this.uploader = new FileUploader({
      url: BaseUrlConstantsService.ASSET_IMAGE_UPLOAD,
      itemAlias: "photo",
    });
    activeRoute.queryParams.subscribe((params) => {
    this.overallStatus=params['overallStatus'];
    this.overall_powertrain_status=params['overall_powertrain_status']
    });
    // this.cdr.detectChanges();
    if (this.router.getCurrentNavigation()?.extras.state) {
      this.fromboiler = this.router.getCurrentNavigation()?.extras.state['fromBoiler'];
      this.routeState = this.router.getCurrentNavigation()?.extras.state;
      if (this.routeState) {
        this.data = this.routeState;
        this.parentModel = this.data?.["templateSelection"]?.primarydevice;
        // console.log("Initial Parent model in constructor");
        // console.log(this.parentModel);
      }
    }
    this.initUserInfo();
    this.utcTime();
    localStorage.setItem("assetBatchID", uuid());
    this.subsystemId=localStorage.getItem('subsystem_id');
    this.boilerName = localStorage.getItem('boiler_name');
    this.boiler_application_name = localStorage.getItem('boiler_application_name');
    this.boiler_site_name = localStorage.getItem('boiler_site_name');

  }
  //bearing Radion button
  bearingButton(value: any, type,isFirstTime:boolean=false) {
    //  on off means is ball bearing selected or not
    this.valuebearing = value;
    if (type == "GEAR") {
      if (value == "on") {
        this.uForm.get("deb_pinion_number").enable();
        this.uForm.get("ndeb_pinion_number").enable();
        if(isFirstTime==false){
          this.uForm.patchValue({
              deb_pinion_number: this.bearingNumbers[1].bearing_number,
              ndeb_pinion_number: this.bearingNumbers[1].bearing_number,
            });
          }
      } else {
        this.uForm.patchValue({
          deb_pinion_number: "NA",
          ndeb_pinion_number: "NA",
        });
        this.uForm.get("deb_pinion_number").disable();
        this.uForm.get("ndeb_pinion_number").disable();
      }
    } else {
      if (value == "on") {
        this.uForm.patchValue({
          de_bearing_number: this.bearingNumbers[1].bearing_number,
          nde_bearing_number: this.bearingNumbers[1].bearing_number,
        });
        this.uForm.get("de_bearing_number").enable();
        this.uForm.get("nde_bearing_number").enable();
      } else {
        this.uForm.patchValue({
          de_bearing_number: "NA",
          nde_bearing_number: "NA",
        });
        this.uForm.get("de_bearing_number").disable();
        this.uForm.get("nde_bearing_number").disable();
      }
    }
  }
  outputBearingButton(value: any) {
    this.outputbearingVal = value;
    if (this.outputbearingVal == "yes") {
      this.uForm.get("outer_bearing_no").at(0).get("ndeb_outer").enable();
      this.uForm.get("outer_bearing_no").at(0).get("deb_outer").enable();
      this.uForm.get("outer_bearing_no").at(0).patchValue({
        ndeb_outer: this.bearingNumbers[1].bearing_number,
        deb_outer: this.bearingNumbers[1].bearing_number,
      });
    } else {
      this.uForm.get("outer_bearing_no").at(0).patchValue({
        ndeb_outer: "NA",
        deb_outer: "NA",
      });
      this.uForm.get("outer_bearing_no").at(0).get("ndeb_outer").disable();
      this.uForm.get("outer_bearing_no").at(0).get("deb_outer").disable();
    }
  }

  //end
  public selectTemplate(value: any) {
    for (let i = 0; i < this.templatesList.length; i++) {
      if (this.templatesList[i] != undefined) {
        if (this.templatesList[i].id === value) {
          this.templatesList[i].status = true;
          this.templatesList[i].title = "In-Progress";
          this.templatesList[i].connected_sensors[i].color = "#d4edda";
        } else {
          if (this.templatesList[i].id === value - 1) {
            this.templatesList[i].title = `Device (${value - 1}) Configured`;
            this.templatesList[i].status = false;
            this.templatesList[i].connected_sensors[i].color = "#ffffff";
          }
        }
      }
    }
    if (this.templatesList.find((x) => x.status === true) != undefined) {
      this.currentFormCount = this.templatesList.find(
        (x) => x.status === true
      ).id;
    }
  }

  gotoTop() {
    this.divToScroll.nativeElement.scrollTop = 30;
  }

  selectNumberOfAssets(id) {
    this.currentFormCount = 1;
    this.fromDataArray = [];
    this.uForm.controls["name"].enable();
    this.uForm.controls["application_id"].enable();
    this.uForm.controls["site_id"].enable();
    this.assetTemplateID = JSON.parse(id);
  }
  AdvanceSettings() {
    this.count++;
    if ((this.count = 1)) {
      this.AdvanceSetting = true;
      this.count++;
    } else {
      this.AdvanceSetting = false;
      this.count--;
    }
  }

  selectSingleDeviceEditAssets(no_of_devices) {
    this.templatesList = [];
    let tempChildArr = [];
    let tempObject = { id: 1, status: false, title: "" };
    for (let i = 0; i < no_of_devices; i++) {
      let childObject = {
        id: this.assetTemplateID,
        color: "#ffffff",
        device_sno: i + 1,
      };
      if (i + 1 === this.currentFormCount) {
        childObject["color"] = "#d4edda";
      }
      tempChildArr.push(childObject);
      tempObject["connected_sensors"] = tempChildArr;
    }
    this.templatesList.push(tempObject);
  }

  // Function to compare versions digit-wise
  isVersionAbove(version1: string, version2: string): boolean {

    const v1Parts = version1.split('.').map(Number);
    const v2Parts = version2.split('.').map(Number);

    // Compare each segment of the version strings
    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
      const v1 = v1Parts[i] || 0; // Default to 0 if undefined
      const v2 = v2Parts[i] || 0; // Default to 0 if undefined

      if (v1 > v2) return true; // Version1 is greater
      if (v1 < v2) return false; // Version2 is greater
    }

    // Versions are equal if all parts match
    return false;
  }

  initUserInfo(): void {
    // console.log("Init user called");
    switch (localStorage.getItem("role")) {
      case "ACCOUNT_MANAGER":
        this.userID = localStorage.getItem("admin_client_id");
        break;
      case "USER":
        this.userID = localStorage.getItem("associated_clientid");
        break;
      case "ADMIN":
        this.userID = localStorage.getItem("admin_client_id");
        break;
      case "CLIENT":
        this.userID = localStorage.getItem("user_id");
        this.adminID = localStorage.getItem("associated_clientid");
        break;
      default:
        //
        break;
    }
    this.assetDetailForm = true;
    this.gearDetailForm = false;
    this.activeRoute.queryParams.subscribe(async (params) => {
      // console.log("Params");
      // console.log(params);
      this.pid = params[`pageRef`];
      if (params["state"] == "FROM_LIST" || params["state"] == "monitor_edit") {
        this.pic = true;
        //this.noofsensors=params[`connected_sensors`].length;
        this.assetType = params[`asset_type`];
        this.assetid = params[`assets_id`];
        this.deviceid = params[`deviceid`];
        this.assetStatus = JSON.parse(params[`assetStatus`]);
        this.firmware_version = params[`firmware`]?.split(".")[0] || "";
        // this.deviceid=params[`inventory_id`];

        this.data = params;
        this.label = params[`label`];
        this.sensorType = params[`sensorType`];
        this.currentLbl = this.label;
        //this.userID=params[`user_id`];
        this.device_sno = params["serial_no"];
        this.device = JSON.parse(params["asset_master_info"]);
        this.noofchildren = this.device.connected_sensors.length - 1;
        this.assetType = params["asset_type"];
        this.parentModel = this.device;
        this.noofasset = this.device.connected_sensors.length;
        this.sensorType = this.setLabelForSensors(this.sensorType);
        // console.log("Parent Model in inituserInfo");
        // console.log(this.parentModel);

        if (params["state"] == "FROM_LIST") {
          this.pic = true;
          this.device.connected_sensors.forEach((s, i) => {
            let sensors = s.template_id.split("_");
            if (this.device.id === s.id) {
              this.currentLbl = sensors[0];
              this.sensorType = sensors[1];
              this.device_sno = s.sno;
              this.sensorType = this.setLabelForSensors(this.sensorType);
            }

            if (this.device.parentS) {
              this.device.asset_type = "MOTOR";
              this.device.imgP = "./assets/motor_n.png";

              this.device.asset_type_s = s.asset_type;
            }
          });
        }
      }
      //if (this.pid == "" || this.pid == "managerAssets") {
      //  this.showEditUsertxt = "Edit Asset";
      if (this.pid === "client-assets" || params["state"] == "monitor_edit") {
        this.assetsID = params[`assets_id`];
        this.onOffStatus = params[`online_status`];
        this.assetStatus = JSON.parse(params[`assetStatus`]);
        this.stateRef = params[`state`];
        this.showUpdateBtn = true;
        this.showEnableUpdateBtn = true;
        this.showSavebtn = false;
        this.showEditUsertxt = "Edit Asset";
        if (this.assetsID !== undefined) {
          this.getallBearing();
          let self = this;
          this.functionDelay = setTimeout(function () {
            self.getAssetsEdit();
            clearTimeout(self.functionDelay);
          }, 1000);
        }
      } else if (this.pid === "managerAssets") {
        this.showEditUsertxt = "Edit Asset";
        const myObj = {
          page_ref: "manager-client-list",
          page_title: "manager clients",
        };
        this.breadcrumbsArray.unshift(myObj);
      } else {
        this.getallBearing();
        this.showUpdateBtn = false;
        this.showEditUsertxt = "Create Asset";
        this.showSavebtn = true;
      }
      //}
    });
    for (let tV = 0; tV <= 40; tV++) {
      this.tempValuesArr.push(tV);
    }
  }
  increment(val) {
    if (val == "Axial") {
      this.uForm.controls["Axial"].setValue(
        (this.uForm.value.Axial * 10 + 0.1 * 10) / 10
      );
    } else if (val == "Horizontal") {
      this.uForm.controls["Horizontal"].setValue(
        (this.uForm.value.Horizontal * 10 + 0.1 * 10) / 10
      );
    } else if (val == "Vertical") {
      this.uForm.controls["Vertical"].setValue(
        (this.uForm.value.Vertical * 10 + 0.1 * 10) / 10
      );
    }
  }
  decrement(val) {
    if (val == "Axial") {
      this.uForm.controls["Axial"].setValue(
        (this.uForm.value.Axial * 10 - 0.1 * 10) / 10
      );
    } else if (val == "Horizontal") {
      this.uForm.controls["Horizontal"].setValue(
        (this.uForm.value.Horizontal * 10 - 0.1 * 10) / 10
      );
    } else if (val == "Vertical") {
      this.uForm.controls["Vertical"].setValue(
        (this.uForm.value.Vertical * 10 - 0.1 * 10) / 10
      );
    }
  }
  async openDetailScreen(sensor, device) {
    this.label = sensor[`lbl`];
    this.currentLbl = this.label;
    this.sensorType = sensor.sensor;
    this.device_sno = sensor.sno;
    this.sensorType = this.setLabelForSensors(this.sensorType);
    this.assetsID = sensor.id;
    this.assetType = device.asset_type;
    this.deviceid = sensor.inventory_id;
    this.assetid = sensor.id;
    this.onOffStatus = sensor[`asset_status`];
    this.assetStatus = sensor.asset_status;
    this.showUpdateBtn = true;
    this.showEnableUpdateBtn = true;
    this.showSavebtn = false;
    this.noofchildren = device.connected_sensors.length;
    this.showEditUsertxt = "Edit Asset";
    if (device.mac_address !== undefined) {
      let deviceStatus = await this.service
        .getDataWithQuery(
          this.deviceStatusURL + "device/status/" + device.mac_address
        )
        .then((statusRes) => {
          return JSON.parse(JSON.stringify(statusRes)).data.body;
        });
      if (deviceStatus != null) {
        this.onOffStatus = deviceStatus.asset_status;
        if (this.assetsID !== undefined) {
          this.getallBearing();
          let self = this;
          this.functionDelay = setTimeout(function () {
            self.getAssetsEdit(sensor.mac_address);
            clearTimeout(self.functionDelay);
          }, 1000);
        }
      } else {
        if (this.assetsID !== undefined) {
          this.getallBearing();
          let self = this;
          this.functionDelay = setTimeout(function () {
            self.getAssetsEdit();
            clearTimeout(self.functionDelay);
          }, 1000);
        }
      }
    }
    // await this.service.getDataWithQuery(`${this.assetsListUrl}/info/detail/v2/${this.userID}/${this.assetId}`).then((assetFullInfo) => { return assetFullInfo });
  }

  onRPMChange(selectedValue) {
    this.variableRPMToggle = selectedValue.value;
    this.uForm.controls["max_rated_rpm"].setValue(0);
    this.uForm.controls["min_rated_rpm"].setValue(0);
  }

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
      const time = date + ":" + houre + ":" + second;
      this.myDate = JSON.parse(JSON.stringify(time));
    }, 1000);
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  getallSitesAndGroupsInfo() {
    if(this.fromboiler === 'boiler'){
      this. getSite = this.eboilerSitesUrl + "eboiler/info/site-app-info/" + this.subsystemId;
    }else{
      this.getSite = this.allSitesUrl + "/" + Math.floor(Math.random() * 90 + 10) + this.userID + Math.floor(Math.random() * 9000 + 1000);
    }
    this.changeService.loader(true);
    this.service
      .getData(
       this.getSite
      )
      .then((res) => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.length !== 0) {
            this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
            if (this.sitesList.length !== 0) {
              const dataF = this.sitesList.filter(
                (result) => result.id === this.siteIDEditCase
              );

              if (dataF[0] !== undefined) {
                if (dataF[0].applications.length !== 0) {
                  this.groupList = dataF[0].applications;
                }
              }
            }
          }
        } else {
          this.showList = false;
          this.emptyMsg = true;
          this.service.showError("Something went wrong.");
        }
      });
    //console.log(this.sitesList)
  }

  byTypeId(a, b) {
    return a === parseInt(b, 10);
  }

  async getAssetsEdit(mac_address=localStorage.getItem('mac_address')) {
    this.uForm.controls["name"].disable();
    this.uForm.controls["application_id_name"].disable();
    this.uForm.controls["site_id_val"].disable();
    this.editable = true;
    this.breadcrumbsArray[1].page_title = "edit assets";
    this.changeService.loader(true);
    this.spinner.show();
    this.service
      .getData(
        this.assetsUrlEdit +
          "/" +
          this.assetsID +
          "/" +
          mac_address
      )
      .then(async (response) => {
        this.spinner.hide();
        this.changeService.loader(false);
        this.olddata = JSON.parse(JSON.stringify(response)).data.body;
        if (JSON.parse(JSON.stringify(response)).data.status === "success") {
          this.currentFormCount = JSON.parse(
            JSON.stringify(response)
          ).data.body.device_sno;
          this.assetTemplateID = JSON.parse(
            JSON.stringify(response)
          ).data.body.template_id;
          this.selectedAssetType = JSON.parse(
            JSON.stringify(response)
          ).data.body.asset_type;
          if (this.selectedAssetType === "MOTOR") {
            this.subAssetType = JSON.parse(
              JSON.stringify(response)
            ).data.body.sub_type;
            if (this.subAssetType === "DC_MOTOR") {
              this.dcmotor = true;
              this.uForm.get("line_frequency").disable();
            }
          } else {
            this.subAssetType = JSON.parse(
              JSON.stringify(response)
            ).data.body.asset_type;
          }

          this.onAssetChangeValue(this.selectedAssetType, "null");
          this.connectedMacAddress = JSON.parse(
            JSON.stringify(response)
          ).data.body.device.mac_address;
          this.atApplicationName =
            JSON.parse(JSON.stringify(response)).data.body.application.name ===
            undefined
              ? ""
              : JSON.parse(JSON.stringify(response)).data.body.application.name;
          this.atSiteName = JSON.parse(
            JSON.stringify(response)
          ).data.body.site.name;
          this.existedInventoryID = JSON.parse(
            JSON.stringify(response)
          ).data.body.device.id;
          this.serialNumber = JSON.parse(
            JSON.stringify(response)
          ).data.body.motor_serial_no;
          this.InventoryIDValue = JSON.parse(
            JSON.stringify(response)
          ).data.body.device.id;
          this.preDeBearingNumber = JSON.parse(
            JSON.stringify(response)
          ).data.body.de_bearing_number;
          this.preNdeBearingNumber = JSON.parse(
            JSON.stringify(response)
          ).data.body.nde_bearing_number;
          this.getDeviceType(
            JSON.parse(JSON.stringify(response)).data.body.device.device_type_id
          );
          this.assetName = JSON.parse(JSON.stringify(response)).data.body.name;
          this.siteID = JSON.parse(JSON.stringify(response)).data.body.site.id;
          this.applicationNewID = JSON.parse(
            JSON.stringify(response)
          ).data.body.application_id;
          if (
            this.selectedAssetType === "MOTOR" ||
            this.selectedAssetType === "FAN_BLOWER" ||
            this.selectedAssetType === "PUMP" ||
            this.selectedAssetType === "COMPRESSOR" ||
            this.selectedAssetType === "JOURNAL_BEARING"
          ) {
            this.driveType =
              JSON.parse(JSON.stringify(response)).data.body.drive_info ===
              undefined
                ? this.driveType
                : JSON.parse(JSON.stringify(response)).data.body.drive_info
                    .drive_type;
            this.onDriveChange(this.driveType);
            if (
              JSON.parse(JSON.stringify(response)).data.body.profile_image !=
              null
            ) {
              this._imgUrl = JSON.parse(
                JSON.stringify(response)
              ).data.body.profile_image;
            }
            this._imageId = JSON.parse(
              JSON.stringify(response)
            ).data.body.image_id;
            this.siteIDEditCase =
              JSON.parse(JSON.stringify(response)).data.body.site === undefined
                ? ""
                : JSON.parse(JSON.stringify(response)).data.body.site.id;
            this.variableRPMToggle =
              JSON.parse(JSON.stringify(response)).data.body.rpm_toggle === null
                ? "fixed"
                : JSON.parse(JSON.stringify(response)).data.body.rpm_toggle;

            //Setting up of form

            if (
              JSON.parse(JSON.stringify(response)).data.body.axis_data ===
              undefined
            ) {
              JSON.parse(JSON.stringify(response)).data.body.axis_data = {};
            }
            this.uForm = this.formBuilder.group({
              device_name: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.device_name ===
                null
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.device_name,
                [Validators.required, this.noWhitespaceValidator]
              ),
              motor_make: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.motor_make
              ),
              equipment_location: new FormControl(JSON.parse(JSON.stringify(response)).data.body.equipment_location),
              frame: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.frame
              ),
              rated_ambient_temprature: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.rated_ambient_temprature
              ),
              insulation_class: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.insulation_class,
                [Validators.required]
              ),
              motor_serial: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.motor_serial_no,
                [Validators.required, this.noWhitespaceValidator]
              ),
              rated_power: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_power,
                [Validators.required]
              ),
              power_unit: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_power_unit,
                [Validators.required]
              ),
              no_of_blades: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.no_of_blades ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.no_of_blades
              ),
              rated_rpm: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_rpm,
                Validators.required
              ),
              max_rated_rpm: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.max_rated_rpm ===
                null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.max_rated_rpm
              ),
              min_rated_rpm: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.min_rated_rpm ===
                null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.min_rated_rpm
              ),
              rpm_toggle: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rpm_toggle ===
                null
                  ? "fixed"
                  : JSON.parse(JSON.stringify(response)).data.body.rpm_toggle
              ),
              rated_voltage: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_voltage
              ),
              power_factor: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.power_factor
              ),
              temperature_sy: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.rated_ambient_temprature_unit
              ),

              site_id: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.site ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.site.id
              ),
              application_id: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.application ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .application_id
              ),
              line_current: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.line_current ===
                null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.line_current
              ),
              Axial: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.axis_data ===
                undefined
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.axis_data
                      .axial
              ),
              Vertical: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.axis_data ===
                undefined
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.axis_data
                      .radial
              ),
              Horizontal: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.axis_data ===
                undefined
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.axis_data
                      .tangential
              ),
              mac_address: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.device ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.device
                      .mac_address,
                [Validators.required, this.noWhitespaceValidator]
              ),
              duty: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.duty
              ),
              percentage_efficiency: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.percentage_efficiency
              ),
              line_frequency: new FormControl(
                JSON.stringify(
                  JSON.parse(JSON.stringify(response)).data.body.line_frequency
                ),
                [Validators.required]
              ),
              data_frequency: new FormControl(
              {
                value: JSON.parse(JSON.stringify(response)).data.body.data_frequency,
                disabled: this.role !== 'ADMIN'
              },
              [Validators.required]
            ),
              config_pull_rate: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.config_pull_rate
              ),
              cloud_push_rate: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.cloud_push_rate
              ),
              sensor_scan_rate: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.cloud_push_rate
              ),
              file_comparison_threshold_percentage: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.file_comparison_threshold_percentage
              ),
              winding_rtd: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.winding_rtd
              ),
              wifi_user: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.wifi_user,
                [Validators.required]
              ),
              wifi_password: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.wifi_password
              ),
              connectivity_type: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.connectivity_type
              ),
              ip: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.ip
              ),
              port: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.port
              ),
              proxy_username: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.proxy_username
              ),
              proxy_password: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.proxy_password
              ),
              name: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.name,
                [Validators.required, this.noWhitespaceValidator]
              ),
              site_id_val: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.site.name
              ),
              application_id_name: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.application.name
              ),
              de_bearing_number: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .de_bearing_number || "NA"
              ),
              nde_bearing_number: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .nde_bearing_number || "NA"
              ),
              nde_bearing: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.nde_bearing
              ),
              de_bearing: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.de_bearing
              ),
              belt_length: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.drive_info ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.drive_info
                      .belt_length
              ),
              belt_number: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.drive_info ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.drive_info
                      .belt_number
              ),
              db_shart_centers: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.drive_info ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.drive_info
                      .db_shart_centers
              ),
              driven_pulley_diameter: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.drive_info ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.drive_info
                      .driven_pulley_diameter
              ),
              driver_pulley_diameter: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.drive_info ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.drive_info
                      .driver_pulley_diameter
              ),
              device_config_update_interval: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .device_config_update_interval === undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .device_config_update_interval
              ),
              vs_scan_rate: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.vs_scan_rate ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.vs_scan_rate,
                [Validators.required]
              ),
              accelero_FS: new FormControl(JSON.parse(JSON.stringify(response)).data.body.accelero_FS ===
                undefined ? 8 : JSON.parse(JSON.stringify(response)).data.body.accelero_FS,
                [Validators.required]
              ),
              machine_threshold_status: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .machine_threshold_status === undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .machine_threshold_status,
                [Validators.required]
              ),
              vs_resolution_mode: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .vs_resolution_mode === undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .vs_resolution_mode
              ),
              sensor_mounting_axis_option: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .sensor_mounting_axis_option === undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .sensor_mounting_axis_option
              ),
              rtd_one: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rtd_one === ""
                  ? "MS"
                  : JSON.parse(JSON.stringify(response)).data.body.rtd_one
              ),
              rtd_two: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rtd_two === ""
                  ? "DE"
                  : JSON.parse(JSON.stringify(response)).data.body.rtd_two
              ),
              rtd_three: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rtd_three === ""
                  ? "NDE"
                  : JSON.parse(JSON.stringify(response)).data.body.rtd_three
              ),
              accelro_odr: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.odr === ""
                  ? "NORMAL"
                  : JSON.parse(JSON.stringify(response)).data.body.odr
              ),
              accelro_odr_high: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.odr_high === ""
                  ? "NORMAL"
                  : JSON.parse(JSON.stringify(response)).data.body.odr_high
              ),
              cloud_pushrate_high: new FormControl(
                {value: JSON.parse(JSON.stringify(response)).data.body
                  .cloud_pushrate_high === null
                  ? 60
                  : JSON.parse(JSON.stringify(response)).data.body
                      .cloud_pushrate_high,
                    disabled: this.role !== 'ADMIN'},
                [Validators.required]
              ),
              cloud_pushrate_anomaly: new FormControl(
                {value: JSON.parse(JSON.stringify(response)).data.body
                  .cloud_pushrate_anomaly === null
                  ? 180
                  : JSON.parse(JSON.stringify(response)).data.body
                      .cloud_pushrate_anomaly,
                    disabled: this.role !== 'ADMIN'},
                [Validators.required]
              ),
              cloud_anomaly_counter: new FormControl(
                {value: JSON.parse(JSON.stringify(response)).data.body
                  .cloud_anomaly_counter === null
                  ? 2
                  : JSON.parse(JSON.stringify(response)).data.body
                      .cloud_anomaly_counter,
                    disabled: this.role !== 'ADMIN'},
                [Validators.required]
              ),
              bearing_radio: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .de_bearing_number === "NA" ||
                JSON.parse(JSON.stringify(response)).data.body
                  .de_bearing_number === "0" ||
                JSON.parse(JSON.stringify(response)).data.body
                  .de_bearing_number === null
                  ? "off"
                  : "on"
              ),
              // bearing_radio: new FormControl("on"),
              audible_adjustment: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .audible_adjustment === null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body
                      .audible_adjustment
              ),
              polePairNumber: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.poles === null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.poles
              ),
              dc_type: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.dc_type
              ),
            });
            if (this.sitesList !== undefined) {
              const dataF = this.sitesList.filter(
                (result) => result.id === this.siteIDEditCase
              );
              if (dataF[0] !== undefined) {
                if (dataF[0].applications.length !== 0) {
                  this.groupList = dataF[0].applications;
                }
              }
            }
            if (
              JSON.parse(JSON.stringify(response)).data.body
                .connectivity_type !== null
            ) {
              this.selectConnectionType(
                JSON.parse(JSON.stringify(response)).data.body.connectivity_type
              );
            }
            if (
              JSON.parse(JSON.stringify(response)).data.body
                .de_bearing_number == "NA" ||
              JSON.parse(JSON.stringify(response)).data.body
                .de_bearing_number == "0" ||
              JSON.parse(JSON.stringify(response)).data.body
                .de_bearing_number == null
            ) {
              $("#de_bearing_number").prop("disabled", true);
              $("#nde_bearing_number").prop("disabled", true);
            } else {
            }
          } else {
            /************EDIT GEAR DATA******* */
            this.onAssetChangeValue("GEAR", "null");
            if (
              JSON.parse(
                JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                  .gmf_data
              ).length != 0
            ) {
              this.GMFvisible = true;
            }
            if (
              JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                .gear_ndeb === "NA"
            ) {
              this.valuebearing = "off";
              this.bearingButton(this.valuebearing, this.assetType);
            }
            if (
              JSON.parse(JSON.stringify(response)).data.body.profile_image !=
              null
            ) {
              this._imgUrl = JSON.parse(
                JSON.stringify(response)
              ).data.body.profile_image;
            }
            this.byTypeId = JSON.parse(
              JSON.stringify(response)
            ).data.body.nde_bearing_number;
            this._imageId = JSON.parse(
              JSON.stringify(response)
            ).data.body.image_id;
            this.siteIDEditCase =
              JSON.parse(JSON.stringify(response)).data.body.site === undefined
                ? ""
                : JSON.parse(JSON.stringify(response)).data.body.site.id;
            this.atApplicationName = JSON.parse(
              JSON.stringify(response)
            ).data.body.application.name;
            this.atSiteName = JSON.parse(
              JSON.stringify(response)
            ).data.body.site.name;
            this.variableRPMToggle =
              JSON.parse(JSON.stringify(response)).data.body.rpm_toggle === null
                ? "fixed"
                : JSON.parse(JSON.stringify(response)).data.body.rpm_toggle;
            this.InventoryIDValue = JSON.parse(
              JSON.stringify(response)
            ).data.body.device.id;
            this.serialNumber = JSON.parse(
              JSON.stringify(response)
            ).data.body.motor_serial_no;
            this.deviceTypeID = JSON.parse(
              JSON.stringify(response)
            ).data.body.device.device_type_id;
            this.existedInventoryID = JSON.parse(
              JSON.stringify(response)
            ).data.body.device.id;
            this.getDeviceType(
              JSON.parse(JSON.stringify(response)).data.body.device
                .device_type_id
            );
            if (
              JSON.parse(JSON.stringify(response)).data.body.gear_info[1]
                .gear_ndeb === "NA" ||
              JSON.parse(JSON.stringify(response)).data.body.gear_info[1]
                .gear_ndeb === "null"
            ) {
              this.outputbearingVal = "no";
              $(document).ready(function () {
                $("#ndeb_outer").prop("disabled", true);
                $("#deb_outer").prop("disabled", true);
              });
            }
            this.uForm = this.formBuilder.group({
              device_name: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.device_name ===
                null
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.device_name,
                [Validators.required, this.noWhitespaceValidator]
              ),
              motor_make: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.motor_make
              ),
              equipment_location: new FormControl(JSON.parse(JSON.stringify(response)).data.body.equipment_location),
              cloud_pushrate_high: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .cloud_pushrate_high === null
                  ? 60
                  : JSON.parse(JSON.stringify(response)).data.body
                      .cloud_pushrate_high
              ),
              cloud_pushrate_anomaly: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .cloud_pushrate_anomaly === null
                  ? 180
                  : JSON.parse(JSON.stringify(response)).data.body
                      .cloud_pushrate_anomaly
              ),
              cloud_anomaly_counter: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .cloud_anomaly_counter === null
                  ? 1
                  : JSON.parse(JSON.stringify(response)).data.body
                      .cloud_anomaly_counter
              ),
              frame: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.frame
              ),
              rated_ambient_temprature: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.rated_ambient_temprature
              ),
              insulation_class: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .insulation_class == null
                  ? "A"
                  : JSON.parse(JSON.stringify(response)).data.body
                      .insulation_class
              ),
              motor_serial: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.motor_serial_no,
                [Validators.required, this.noWhitespaceValidator]
              ),
              rated_power: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_power,
                [Validators.required]
              ),
              power_unit: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_power_unit,
                [Validators.required]
              ),
              GMF_unit: new FormControl(
                JSON.parse(
                  JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                    .gmf_data
                ).length != 0
                  ? "yes"
                  : "no"
              ),
              bearing_radio: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                  .gear_deb === "NA" ||
                JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                  .gear_deb === "0" ||
                JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                  .gear_deb === null
                  ? "off"
                  : this.valuebearing
              ),
              output_bearing_radio: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.gear_info[1]
                  .gear_deb === null
                  ? "no"
                  : this.outputbearingVal
              ),
              GMFdrop: new FormControl(
                JSON.parse(
                  JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                    .gmf_data
                ).length
              ),
              rated_rpm: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_rpm
              ),
              max_rated_rpm: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.max_rated_rpm ===
                null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.max_rated_rpm
              ),
              min_rated_rpm: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.min_rated_rpm ===
                null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body
                      .min_rated_rpm,
                [Validators.required]
              ),
              line_current: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.line_current ===
                null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body.line_current
              ),
              rpm_toggle: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rpm_toggle ===
                null
                  ? "fixed"
                  : JSON.parse(JSON.stringify(response)).data.body.rpm_toggle
              ),
              rated_voltage: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rated_voltage
              ),
              power_factor: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.power_factor
              ),
              temperature_sy: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.rated_ambient_temprature_unit
              ),
              site_id: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.site ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.site.id,
                [Validators.required]
              ),
              vs_scan_rate: new FormControl(
                {value: JSON.parse(JSON.stringify(response)).data.body.vs_scan_rate ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.vs_scan_rate,
                disabled: this.role !== 'ADMIN'}
              ),
              machine_threshold_status: new FormControl(
                {
                  value: JSON.parse(JSON.stringify(response)).data.body
                  .machine_threshold_status === undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .machine_threshold_status,
                  disabled: this.role !== 'ADMIN'},
              ),
              accelero_FS: new FormControl(JSON.parse(JSON.stringify(response)).data.body.accelero_FS ===
                undefined ? 8 : JSON.parse(JSON.stringify(response)).data.body.accelero_FS,
                [Validators.required]
              ),
              application_id: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.application ===
                undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .application_id,
                [Validators.required]
              ),
              mac_address: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.device
                  .mac_address === undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body.device
                      .mac_address,
                [Validators.required, this.noWhitespaceValidator]
              ),
              duty: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.duty
              ),
              percentage_efficiency: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.percentage_efficiency
              ),
              line_frequency: new FormControl(
                JSON.stringify(
                  JSON.parse(JSON.stringify(response)).data.body.line_frequency
                ),
                [Validators.required]
              ),
              data_frequency: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.data_frequency,
                [Validators.required]
              ),
              config_pull_rate: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.config_pull_rate
              ),
              cloud_push_rate: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.cloud_push_rate
              ),
              sensor_scan_rate: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.cloud_push_rate
              ),
              file_comparison_threshold_percentage: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.file_comparison_threshold_percentage,
                [Validators.required]
              ),
              winding_rtd: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.winding_rtd
              ),
              wifi_user: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.wifi_user,
                [Validators.required]
              ),
              wifi_password: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.wifi_password
              ),
              connectivity_type: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.connectivity_type
              ),
              ip: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.ip
              ),
              port: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.port
              ),
              proxy_username: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.proxy_username
              ),
              proxy_password: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.proxy_password
              ),
              name: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.name,
                [Validators.required, this.noWhitespaceValidator]
              ),
              site_id_val: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.site.name
              ),
              application_id_name: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.application.name
              ),
              de_bearing_number: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.de_bearing_number
              ),
              nde_bearing_number: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.nde_bearing_number
              ),
              nde_bearing: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.nde_bearing
              ),
              de_bearing: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.de_bearing
              ),
              gear_make: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[0].gear_make
              ),
              pinion_gear_rpm: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[0].gear_rpm,
                [Validators.required, this.noWhitespaceValidator]
              ),
              pinion_gear_teeth: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[0].gear_teeth
              ),
              deb_pinion_number: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[0].gear_deb,
                [Validators.required]
              ),
              ndeb_pinion_number: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[0].gear_ndeb,
                [Validators.required]
              ),
              outer_bearing_no: this.formBuilder.array([]),
              gmf_data: this.formBuilder.array([]),
              outer_gear_rpm: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[1].gear_rpm,
                [Validators.required, this.noWhitespaceValidator]
              ),
              number_of_stages: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[0].number_of_stages
              ),
              gear_count: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.gear_info
                  .length - 1
              ),
              outer_teeth: new FormControl(
                JSON.parse(
                  JSON.stringify(response)
                ).data.body.gear_info[1].gear_teeth
              ),
              sensor_mounting_axis_option: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .sensor_mounting_axis_option === undefined
                  ? ""
                  : JSON.parse(JSON.stringify(response)).data.body
                      .sensor_mounting_axis_option
              ),
              rtd_one: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rtd_one === ""
                  ? "MS"
                  : JSON.parse(JSON.stringify(response)).data.body.rtd_one
              ),
              rtd_two: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rtd_two === ""
                  ? "DE"
                  : JSON.parse(JSON.stringify(response)).data.body.rtd_two
              ),
              rtd_three: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.rtd_three === ""
                  ? "NDE"
                  : JSON.parse(JSON.stringify(response)).data.body.rtd_three
              ),
              accelro_odr: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.odr === ""
                  ? "NORMAL"
                  : JSON.parse(JSON.stringify(response)).data.body.odr
              ),
              accelro_odr_high: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body.odr_high === ""
                  ? "NORMAL"
                  : JSON.parse(JSON.stringify(response)).data.body.odr_high
              ),
              audible_adjustment: new FormControl(
                JSON.parse(JSON.stringify(response)).data.body
                  .audible_adjustment === null
                  ? 0
                  : JSON.parse(JSON.stringify(response)).data.body
                      .audible_adjustment
              ),
            });
            if (
              JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                .gear_ndeb != "NA"
            ) {
              this.bearingButton(this.valuebearing, "GEAR",true);
            }
            if (
              JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                .gear_ndeb == "NA" ||
              JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                .gear_ndeb == "0" ||
              JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                .gear_ndeb == null
            ) {
              $(document).ready(function () {
                $("#deb_pinion_number").prop("disabled", true);
                $("#deb_pinion_number").prop("disabled", true);
                $("#ndeb_pinion_number").prop("disabled", true);
                $("#deb_pinion_number").attr("disabled", true);
                $("#deb_pinion_number").attr("disabled", true);
              });

            }
            if (
              JSON.parse(JSON.stringify(response)).data.body.gear_info[1]
                .gear_ndeb == "NA" ||
              JSON.parse(JSON.stringify(response)).data.body.gear_info[1]
                .gear_ndeb == "0" ||
              JSON.parse(JSON.stringify(response)).data.body.gear_info[1]
                .gear_ndeb == null
            ) {
              $(document).ready(function () {
                $("#ndeb_outer").prop("disabled", true);
                $("#deb_outer").prop("disabled", true);
              });
            }

            if (this.sitesList !== undefined) {
              const dataF = this.sitesList.filter(
                (result) => result.id === this.siteIDEditCase
              );
              if (dataF[0] !== undefined) {
                if (dataF[0].applications.length !== 0) {
                  this.groupList = dataF[0].applications;
                }
              }
            }
            this.inputFieldLength = JSON.parse(
              JSON.stringify(response)
            ).data.body.gear_info;
            if (
              JSON.parse(JSON.stringify(response)).data.body
                .connectivity_type !== null
            ) {
              this.selectConnectionType(
                JSON.parse(JSON.stringify(response)).data.body.connectivity_type
              );
            }
            if (
              JSON.parse(JSON.stringify(response)).data.body.gear_info
                .length !== 0
            ) {
              for (
                let me = 0;
                me <
                JSON.parse(JSON.stringify(response)).data.body.gear_info.length;
                me++
              ) {
                if (
                  JSON.parse(JSON.stringify(response)).data.body.gear_info[me]
                    .gear_type === "OUTER"
                ) {
                  this.outer_bearing_no().push(
                    this.editgroup_name(
                      JSON.parse(JSON.stringify(response)).data.body.gear_info[
                        me
                      ].gear_ndeb || "NA",
                      JSON.parse(JSON.stringify(response)).data.body.gear_info[
                        me
                      ].gear_deb || "NA",
                      JSON.parse(JSON.stringify(response)).data.body.gear_info[
                        me
                      ].id
                    )
                  );
                }
              }
            }
            if (
              JSON.parse(
                JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                  .gmf_data
              ).length !== 0
            ) {
              for (
                let count = 0;
                count <
                JSON.parse(
                  JSON.parse(JSON.stringify(response)).data.body.gear_info[0]
                    .gmf_data
                ).length;
                count++
              ) {
                this.gmf_data().push(
                  this.editgroup_gmfname(
                    JSON.parse(
                      JSON.parse(JSON.stringify(response)).data.body
                        .gear_info[0].gmf_data
                    )[count].gmfName,
                    JSON.parse(
                      JSON.parse(JSON.stringify(response)).data.body
                        .gear_info[0].gmf_data
                    )[count].gmfNumber
                  )
                );
              }
            }
          }
          this.ssidUser = JSON.parse(
            JSON.stringify(response)
          ).data.body.wifi_user;
          this.passwordSsid = JSON.parse(
            JSON.stringify(response)
          ).data.body.wifi_password;
          this.datafreq = JSON.parse(
            JSON.stringify(response)
          ).data.body.data_frequency;
          this.odrValue = JSON.parse(JSON.stringify(response)).data.body.odr;
          this.odrValueHigh = JSON.parse(
            JSON.stringify(response)
          ).data.body.odr_high;
          this.cloudPushRateAnomaly = JSON.parse(
            JSON.stringify(response)
          ).data.body.cloud_pushrate_anomaly;
          this.cloudAnomalyCounter = JSON.parse(
            JSON.stringify(response)
          ).data.body.cloud_anomaly_counter;
          this.cloudPushrateHigh = JSON.parse(
            JSON.stringify(response)
          ).data.body.cloud_pushrate_high;
          this.scanRateValue = JSON.parse(
            JSON.stringify(response)
          ).data.body.vs_scan_rate;
          this.machinethresholdvalue = JSON.parse(
            JSON.stringify(response)
          ).data.body.machine_threshold_status;
          this.ratedPower = JSON.parse(
            JSON.stringify(response)
          ).data.body.rated_power;
          this.uForm.controls["name"].disable();
          this.uForm.controls["application_id_name"].disable();
          this.uForm.controls["site_id_val"].disable();
        } else {
          this.service.showError("Something went wrong.");
        }
        if (
          JSON.parse(JSON.stringify(response)).data.body.de_bearing_number ==
            "NA" ||
          JSON.parse(JSON.stringify(response)).data.body.de_bearing_number ==
            "0" ||
          (JSON.parse(JSON.stringify(response)).data.body.de_bearing_number ==
            null &&
            this.assetType != "GEAR")
        ) {
          // this.bearingButton("off", "NA");
        } else if (this.assetType != "GEAR") {
          // this.bearingButton("on", "NA");
          // this.uForm.get("de_bearing_number").enable();
          // this.uForm.get("nde_bearing_number").enable();
        }
      });
  }

  getDeviceType(type_id) {
    this.service
      .getData(this.deviceTypeUrl + "/" + type_id)
      .then((response) => {
        const deviceType = JSON.parse(JSON.stringify(response)).data.body.name;
        if (deviceType.toLowerCase().includes("accelero")) {
          this.isItAccelroDevice = true;
        } else {
          this.isItAccelroDevice = false;
        }
      });
  }

  addNewBearing() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "300px",
      maxWidth: "100%",
      data: {
        type: "DialogForBearingNumber",
        data: {},
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (result.data.bearing_number == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.bbf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.bcf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.irf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.orf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else {
          let body = {
            bbf: result.data.bbf,
            bcf: result.data.bcf,
            bearing_number: result.data.bearing_number,
            irf: result.data.irf,
            orf: result.data.orf,
          };
          this.service.postData(this.createBearingNumber, body).then((res) => {
            if (JSON.parse(JSON.stringify(res)).data.status === "error") {
              this.service.showError("Bearing number already exist.");
            } else if (
              JSON.parse(JSON.stringify(res)).data.status === "success"
            ) {
              this.service.showSuccess("New bearing added successfully.");
              this.getallBearing();
            }
          });
        }
      } else {
      }
    });
  }

  addNewBeltNumber() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "300px",
      maxWidth: "100%",
      data: {
        type: "DialogForBeltNumber",
        data: {},
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (Object.keys(result).length !== 0) {
          if (result.data.belt_number === undefined) {
            this.service.showError("Belt number can't be empty!");
          } else if (result.data.belt_length === undefined) {
            this.service.showError("Belt length can't be empty!");
          } else {
            let body = {
              belt_number: result.data.belt_number,
              belt_length: result.data.belt_length,
            };
            this.service
              .postData(this.updateAssetsUrl + "/belt", body)
              .then((res) => {
                if (JSON.parse(JSON.stringify(res)).data.status === "error") {
                  this.service.showError("Belt number already exist.");
                } else if (
                  JSON.parse(JSON.stringify(res)).data.status === "success"
                ) {
                  this.service.showSuccess("New bealt added successfully.");
                  this.getBeltInfo();
                }
              });
          }
        } else {
          this.service.showError("Belt number can't be empty!");
        }
      }
    });
  }

  private subscription: Subscription = new Subscription();

  uploadAndProgress(files: any, signedRequest, imageurl, userId, cId) {
    const formData = new FormData();
    this.subscription.add(
      this.http
        .put(signedRequest, files[0], {
          reportProgress: true,
          observe: "events",
        })
        .subscribe((event) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.percentDone = Math.round((100 * event.loaded) / event.total);
          } else if (event instanceof HttpResponse) {
            this.showCancelBtn = false;
            this.fileName = "";
            this.uploadSuccess = true;
            this._imgUrl = imageurl;
          }
        })
    );
  }

  cancelClick() {
    this.subscription.unsubscribe();
    this.fileName = "";
    this.showCancelBtn = false;
  }

  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: this.pid,
      },
    };
    this.router.navigate([name], navigationExtras);
  }

  getBeltInfo() {
    this.service.getData(this.updateAssetsUrl + "/belt/all").then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
        this.service.showError(msgErr);
      } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        this.beltData = JSON.parse(JSON.stringify(res)).data.body;
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  filterUsers(value) {
    let tempArr = this.allDevices;
    if (tempArr != undefined) {
      let passed = tempArr.find(
        (item) => item.mac_address.toLowerCase() === value.toLowerCase()
      );
      if (passed === undefined) {
        this.ivInventoryMsg = "Invalid device id.";
      } else {
        this.ivInventoryMsg = "";
      }
      this.filterdOptions = tempArr.filter((item) =>
        item.mac_address
          .toLowerCase()
          .includes(this.uForm.value.mac_address.toLowerCase())
      );
    } else {
      if (this.connectedMacAddress != undefined) {
        if (this.connectedMacAddress.toLowerCase() === value.toLowerCase()) {
          this.ivInventoryMsg = "";
        } else {
          this.ivInventoryMsg = "You don't have assigned device id.";
        }
      } else {
        this.ivInventoryMsg = "You don't have assigned device id.";
      }
    }
  }

  selectedOption() {
    this.ivInventoryMsg = "";
  }

  onFilterOptionSelected(optionSelected) {
    let objVal = this.allDevices.filter(
      (x) => x.mac_address === optionSelected
    );
    this.uForm.controls.mac_address.setValue(objVal[0].mac_address);
    this.InventoryIDValue = objVal[0].id;
    this.connectedMacAddress = objVal[0].mac_address;
    this.uForm.controls["motor_serial"].setValue(objVal[0].name);
    this.deviceTypeID = objVal[0].device_type_id;
    this.getDeviceType(this.deviceTypeID);
  }

  async ngOnInit() {
    this.boilerName = localStorage.getItem('subsystem_name');
    this.applicationName = localStorage.getItem('ApplicationName');
    this.siteName = localStorage.getItem('SiteName');
    this.activeRoute.queryParams.subscribe(async (params) => {
      this.firmware_version = params[`firmware`]?.split(".")[0] || "";
      this.current_firmware_version = params[`firmware`];
      this.firmware_version_check=this.isVersionAbove("5.1.46", this.current_firmware_version);
    });
    this.options = [
      { value: "HIGH", label: "High (Fₘₐₓ = 3400Hz)"},
      { value: "NORMAL", label: "Normal (Fₘₐₓ = 1700Hz)"},
      { value: "LOW", label: "Low (Fₘₐₓ = 200Hz)"}
    ];

     if(!this.firmware_version_check || this.firmware_version == '4.1.45'){
      this.options.push({ value: "EXTRALOW", label: "Extra Low (Fₘₐₓ = 100Hz)" });
      this.options.push({ value: "EXTRAEXTRALOW", label: "Extra Extra Low (Fₘₐₓ = 50Hz)" });
      this.options.push({value: "UltraUltraLow", label: "Ultra Ultra Low"});
      this.options.push({value: "UltraLow", label: "Ultra Low"});
    }
    
    this.selectedAssetType = "";
    this.tempValue = this.selectedAssetType;
    let getLink = window.location.href;
    const { hostname } = new URL(getLink);
    const [subdomain] = hostname.split(".");
    this.ENV_TYPE = subdomain;
    this.getBeltInfo();
    this.uForm = this.formBuilder.group({
      cloud_pushrate_high: new FormControl(60, [Validators.required]),
      cloud_pushrate_anomaly: new FormControl(180, [Validators.required]),
      cloud_anomaly_counter: new FormControl(1, [Validators.required]),
      Axial: new FormControl(1, [Validators.required]),
      Horizontal: new FormControl(1, [Validators.required]),
      Vertical: new FormControl(1, [Validators.required]),
      accelro_odr_high: new FormControl("NORMAL"),
      accelro_odr: new FormControl("NORMAL"),
      motor_make: new FormControl(""),
      equipment_location: new FormControl(""),
      line_current: new FormControl("0"),
      frame: new FormControl(""),
      device_name: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      rated_ambient_temprature: new FormControl("0"),
      insulation_class: new FormControl("", [Validators.required]),
      motor_serial: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      rated_power: new FormControl("", [Validators.required]),
      rated_rpm: new FormControl("", Validators.required),
      max_rated_rpm: new FormControl(""),
      min_rated_rpm: new FormControl(""),
      rpm_toggle: new FormControl("fixed"),
      rated_voltage: new FormControl(""),
      power_factor: new FormControl(""),
      temperature_sy: new FormControl(""),
      power_unit: new FormControl("KW"),
      GMF_unit: new FormControl("no"),
      site_id: new FormControl("KW"),
      site_id_val: new FormControl(""),
      application_id_name: new FormControl(""),
      // master_product_type: new FormControl("",Validators.required),// select master  type as mini std rtd piezo
      // gw_devicetype_id: new FormControl(""), // only when adding piezo sensor  this is gateway device type
      // gateway_mac_address: new FormControl(""), // only when adding piezo sensor this is gateway mac address
      // gateway_summary_push_rate: new FormControl(""), // only when adding piezo sensor this is gateway mac address
      // gateway_anomaly_push_rate: new FormControl(""), // only when adding piezo sensor this is gateway mac address
      // piezo_axis: new FormControl(""),
      application_id: new FormControl("", Validators.required),
      mac_address: new FormControl("", Validators.required),
      duty: new FormControl(""),
      percentage_efficiency: new FormControl(""),
      line_frequency: new FormControl("", [Validators.required]),
      data_frequency: new FormControl(15, [Validators.required]),
      config_pull_rate: new FormControl(60),
      cloud_push_rate: new FormControl(60),
      sensor_scan_rate: new FormControl(15),
      file_comparison_threshold_percentage: new FormControl(60),
      winding_rtd: new FormControl("0"),
      connectivity_type: new FormControl("wifi"),
      wifi_user: new FormControl("EnerticsWiFi", [Validators.required]),
      wifi_password: new FormControl("enertics"),
      ip: new FormControl(""),
      port: new FormControl(""),
      proxy_username: new FormControl(""),
      proxy_password: new FormControl(""),
      name: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      de_bearing_number: new FormControl("NA"),
      nde_bearing_number: new FormControl("NA"),
      nde_bearing: new FormControl("0"),
      de_bearing: new FormControl("0"),
      device_config_update_interval: new FormControl(60),
      vs_scan_rate: new FormControl(15, [Validators.required]),
      machine_threshold_status: new FormControl(0.5, [Validators.required]),
      accelero_FS: new FormControl(8, [Validators.required]),
      vs_resolution_mode: new FormControl("NORMAL"),

      sensor_mounting_axis_option: new FormControl("PARALLEL_SIDE"),
      rtd_one: new FormControl("MS"),
      rtd_two: new FormControl("DE"),
      rtd_three: new FormControl("NDE"),
      belt_length: new FormControl(""),
      belt_number: new FormControl(""),
      db_shart_centers: new FormControl(""),
      driven_pulley_diameter: new FormControl(""),
      driver_pulley_diameter: new FormControl(""),
      outer_bearing_no: this.formBuilder.array([]),
      gmf_data: this.formBuilder.array([]),
      drive_type: new FormControl(""),
      no_of_blades: new FormControl(1),
      bearing_radio: new FormControl("off"),
      output_bearing_radio: new FormControl("yes"),
      audible_adjustment: new FormControl([0]),
      polePairNumber: new FormControl([0]),
      dc_type: new FormControl(""),
      number_of_stages: new FormControl(0)
    });



    if (this.showEditUsertxt != "Edit Asset") {
      this.uForm.get("de_bearing_number").disable();
      this.uForm.get("nde_bearing_number").disable();

    }
    else {
      this.uForm.get('data_frequency').disable();
    }

    this.uploader.onBuildItemForm = (item, form) => {
      form.append("token", localStorage.getItem("token"));
      form.append("asset_id", this.assetsID);
      form.append("user_id", this.userID);
    };
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      if (status === 200) {
        if (this.assetsID != undefined) {
          this.service
            .getData(
              this.imageAssetUploadUrl +
                "/" +
                this.assetsID +
                "/" +
                localStorage.getItem("mac_address")
            )
            .then((response) => {
              if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
                this._imgUrl = JSON.parse(
                  JSON.stringify(response)
                ).data.body[0].relative_url;
                this.fileName = "";
                this.service.showSuccess("Saved successfully");
              }
            });
        }
      } else {
        this.service.showError("Upload unsuccessfully");
      }
    };
    this.getallDevices();
    this.getallSitesAndGroupsInfo();
    this.showProfileImage();

    this.getLastCalibrationDate();
  }
  get audibleSoundList(): number[] {
    return Array.from({ length: 31 }, (_, i) => i);
  }
  get NumberOfPolePairs(): number[] {
    return Array.from({ length: 9 }, (_, i) => i);
  }
  ngAfterViewInit() {}

  async getLastCalibrationDate() {
    try {
      if(this.assetsID != undefined){

        const response = await this.service.getData(
          this.assetsUrlEdit +
          "/" +
          this.assetsID +
          "/" +
          localStorage.getItem("mac_address")
        );

      const axisDataTime = JSON.parse(JSON.stringify(response)).data.body
        .axis_data.time;
      const clientTimeZone = localStorage.getItem("clientTimeZone");

      if (axisDataTime === "No Calibration Had Been Done Yet") {
        this.lastCalibrationDate = "No Calibration Had Been Done Yet";
      } else {
        const lastCalDateClientTZ = moment.utc(axisDataTime).tz(clientTimeZone);
        const formattedDate = lastCalDateClientTZ.format("YYYY-MM-DD HH:mm");
        this.lastCalibrationDate = formattedDate;
      }
      }
    } catch (error) {
      this.lastCalibrationDate = "No Calibration Had Been Done Yet";
    }
  }

  showProfileImage() {
    if (this.assetsID != undefined) {
      this.service
        .getData(
          this.imageAssetUploadUrl +
            "/" +
            this.assetsID +
            "/" +
            localStorage.getItem("mac_address")
        )
        .then((response) => {
          if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
            let body = JSON.parse(JSON.stringify(response)).data.body[0];
            if (
              body !== undefined &&
              body.relative_url !== undefined &&
              body.relative_url !== ""
            ) {
              this._imgUrl = JSON.parse(
                JSON.stringify(response)
              ).data.body[0].relative_url;
              this.pic = true;
            }
          } else {
            this.pic = false;
          }
        });
    }
  }

  upload(files: any) {
    if (files[0].name !== undefined && files[0].name === "") {
      this.fileName = "";
    } else {
      this.showCancelBtn = true;
      this.fileName = files[0].name;
      if (this.showEditUsertxt !== "Create Asset") {
        var reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this._imgUrl = reader.result;
        };
        this.uploader.uploadAll();
        this.uploader.onProgressItem = (progress: any) => {
          this.percentDone = progress["progress"];
          this.pic = true;
        };
      } else {
        this.pic = true;
        var reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this._imgUrl = reader.result;
        };
      }
    }
  }

  getallBearing() {
    this.service.getData(this.assetsBearingUrl).then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        let result = JSON.parse(JSON.stringify(res)).data.body;
        this.bearingNumbers = result;
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  getallDevices() {
    this.changeService.loader(true);
    this.service
      .getData(
        this.clientDeviceUrl +
          "/" +
          Math.floor(Math.random() * 90 + 10) +
          this.userID +
          Math.floor(Math.random() * 9000 + 1000)
      )
      .then((res) => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
            if (JSON.parse(JSON.stringify(res)).data.body.body !== undefined) {
              this.allDevices = JSON.parse(JSON.stringify(res)).data.body.body;
              this.filterdOptions = this.allDevices;
            } else {
              this.allDevices = JSON.parse(JSON.stringify(res)).data.body;
              this.filterdOptions = this.allDevices;
            }
          }
        } else {
          this.service.showError("Something went wrong.");
        }
        console.log(this.filterdOptions);
      });

  }

  removeUserImage(val) {
    this.pic = false;
    this.service
      .getData(this.imageUploadUrl + "/remove/asset/" + this.assetsID)
      .then((response) => {
        this._imgUrl = "./assets/img-new/default_user.png";
        this.service.showSuccess("Removed successfully.");
      });
  }

  selectSite(siteValue) {
    if (this.sitesList.length !== 0) {
      // console.log(this.sitesList);
      const dataF = this.sitesList.filter(
        (result) => result.id === parseInt(siteValue)
      );
      this.preValueApplication = dataF[0].applications[0].id;
      this.uForm.controls["application_id"].setValue(this.preValueApplication);
      this.groupList = dataF[0].applications;
    }
  }

  selectSiteApp(siteValue, application_id) {
    if (this.sitesList.length !== 0) {
      const dataF = this.sitesList.filter(
        (result) => result.id === parseInt(siteValue)
      );
      this.preValueApplication = application_id;
      this.uForm.controls["application_id"].setValue(this.preValueApplication);
      this.groupList = dataF[0].applications;
    }
  }

  selectGroup(selectGroup) {}

  onKey(event) {
    const inputValue = event.target.value;
    if (inputValue < 2) {
      this.invalidFrequencyValue = true;
    } else {
      this.invalidFrequencyValue = false;
    }
  }

  onCategorySelected(value) {
    let inventoryObj = this.allDevices.filter(
      (x) => x.id === parseInt(value)
    )[0];
    this.connectedMacAddress = inventoryObj.mac_address;
    this.deviceTypeID = inventoryObj.device_type_id;
  }

  resetMotorInputFields() {
    this.uForm.controls["site_id"].setValue(
      JSON.parse(localStorage.getItem("siteID"))
    );
    this.uForm.controls["application_id"].setValue(
      JSON.parse(localStorage.getItem("applicationID"))
    );
    this.uForm.controls["name"].setValue(localStorage.getItem("assetName"));
    this.uForm.controls["name"].disable();
    this.uForm.controls["application_id"].disable();
    this.uForm.controls["site_id"].disable();
    this.uForm.controls["mac_address"].reset();
    this.uForm.controls["motor_serial"].reset();
    this.uForm.controls["device_name"].reset();
    this.uForm.controls["insulation_class"];
    // this.uForm.controls['']

    return;
  }

  saveDraft() {
    // console.log("VARIALBE MIN RATED RPM IS :"+this.uForm.value.rated_rpm);
    // console.log("Varialne RPM toggle is On :"+this.variableRPMToggle);
    let _imgId = null;
    if (this.uploadSuccess) {
      _imgId = this.id;
    } else if (this._imageId != null) {
      _imgId = this._imageId;
    }

    if (this.invalidFrequencyValue) {
      return this.service.showError("Invalid sensor data publish frequency.");
    }
    if (this.variableRPMToggle !== "fixed") {
      if (!this.uForm.value.min_rated_rpm) {
        return this.service.showError("minimum rated rpm can't be empty!");
      } else if (!this.uForm.value.max_rated_rpm) {
        return this.service.showError("maximum rated rpm can't be empty!");
      } else {
        if (
          parseInt(this.uForm.value.min_rated_rpm) <=
          parseInt(this.uForm.value.max_rated_rpm)
        ) {
          /********************************* */
        } else {
          return this.service.showError(
            "maximum rpm must be greater than minimum rpm."
          );
        }
      }
    }
    if (this.ivInventoryMsg !== "") {
      return this.service.showError("Please check configurations again!");
    }
    if (this.uForm.value.application_id != undefined) {
      localStorage.setItem("applicationID", this.uForm.value.application_id);
    }
    if (this.uForm.value.site_id != undefined) {
      localStorage.setItem("siteID", this.uForm.value.site_id);
    }
    if (this.uForm.value.name != undefined) {
      localStorage.setItem("assetName", this.uForm.value.name);
    }
    if (JSON.parse(this.uForm.value.cloud_pushrate_anomaly) < 1) {
      return this.service.showError(
        "Cloud push rate anomaly value can't be less than 1."
      );
    }
    if (
      JSON.parse(this.uForm.value.cloud_pushrate_high) <
      JSON.parse(this.uForm.value.data_frequency)
    ) {
      return this.service.showError(
        "Cloud push rate high must be greater than sensor data publish frequency."
      );
    }

    if (this.showEditUsertxt === "Create Asset") {
      // if(this.selectedAssetType === 'INDUCTION_MOTOR' || this.selectedAssetType === 'DC_MOTOR' || this.selectedAssetType === 'SYNCHRONOUS_MOTOR' || this.selectedAssetType === 'ALTERNATOR'){
      //   this.selectedAssetType = 'MOTOR';
      // }
      // if(this.selectedAssetType === 'MOTOR'){
      //   this.subAssetType =
      // }
      this.currentFormCount += 1;
      const body = {
        asset_batch_id: localStorage.getItem("assetBatchID"),
        user_id: this.userID,
        device_name: this.uForm.value.device_name,
        device_sno: this.currentFormCount,
        axial: this.uForm.value.Axial,
        radial: this.uForm.value.Vertical,
        tangential: this.uForm.value.Horizontal,
        template_id:
          this.currentLbl +
          "_" +
          this.sensorDetails.sensor +
          "_" +
          this.sensorDetails.parent,
        line_current: this.uForm.value.line_current,
        accelro_odr: this.uForm.value.accelro_odr,
        accelro_odr_high: this.uForm.value.accelro_odr_high,
        cloud_pushrate_high: this.uForm.value.cloud_pushrate_high,
        cloud_pushrate_anomaly: this.uForm.value.cloud_pushrate_anomaly,
        cloud_anomaly_counter: this.uForm.value.cloud_anomaly_counter,
        device_type_id: this.deviceTypeID,
        admin_id: this.adminID,
        asset_on_off_status: this.onOffStatus,
        motor_make: this.uForm.value.motor_make,
        equipment_location: this.uForm.value.equipment_location,
        insulation_class: this.uForm.value.insulation_class,
        frame: this.uForm.value.frame,
        frame_unit: "L",
        asset_type:
          this.selectedAssetType === "INDUCTION_MOTOR" ||
          this.selectedAssetType === "DC_MOTOR" ||
          this.selectedAssetType === "SYNCHRONOUS_MOTOR" ||
          this.selectedAssetType === "ALTERNATOR"
            ? "MOTOR"
            : this.selectedAssetType,
        subtype: this.subAssetType,
        rated_ambient_temprature: this.uForm.value.rated_ambient_temprature,
        rated_ambient_temprature_unit: this.uForm.value.temperature_sy,
        power_factor: this.uForm.value.power_factor,
        rated_power: this.uForm.value.rated_power,
        rated_power_unit: this.uForm.value.power_unit,
        rated_rpm: this.uForm.value.rated_rpm,
        max_rated_rpm:
          this.variableRPMToggle === "fixed"
            ? 0
            : this.uForm.value.max_rated_rpm,
        min_rated_rpm:
          this.variableRPMToggle === "fixed"
            ? this.uForm.value.rated_rpm
            : this.uForm.value.min_rated_rpm,
        rpm_toggle: this.uForm.value.rpm_toggle,
        percentage_efficiency: this.uForm.value.percentage_efficiency,
        rated_voltage: this.uForm.value.rated_voltage,
        motor_serial_no: this.uForm.value.motor_serial,
        line_frequency: this.uForm.value.line_frequency,
        duty: this.uForm.value.duty,
        inventory_id: this.InventoryIDValue,
        mac_address: this.uForm.value.mac_address,
        site_id: JSON.parse(localStorage.getItem("siteID")),
        application_id: JSON.parse(localStorage.getItem("applicationID")),
        data_frequency: this.uForm.value.data_frequency,
        config_pull_rate: this.uForm.value.config_pull_rate,
        cloud_push_rate: this.uForm.value.cloud_push_rate,
        sensor_scan_rate: this.uForm.value.sensor_scan_rate,
        file_comparison_threshold_percentage:
          this.uForm.value.file_comparison_threshold_percentage,
        winding_rtd: this.uForm.value.winding_rtd,
        wifi_user: this.uForm.value.wifi_user,
        wifi_password: this.uForm.value.wifi_password,
        connectivity_type: this.uForm.value.connectivity_type,
        ip: this.uForm.value.ip,
        port: this.uForm.value.port,
        proxy_username: this.uForm.value.proxy_username,
        proxy_password: this.uForm.value.proxy_password,
        name: localStorage.getItem("assetName"),
        de_bearing_number: this.uForm.value.de_bearing_number,
        nde_bearing_number: this.uForm.value.nde_bearing_number,
        nde_bearing: this.uForm.value.nde_bearing,
        de_bearing: this.uForm.value.de_bearing,
        gear_make: this.uForm.value.gear_make,
        gear_type_one: this.uForm.value.gear_one,
        gear_type_two: this.uForm.value.gear_two,
        outer_gear_rpm: this.uForm.value.outer_gear_rpm,
        number_of_stages: this.uForm.value.number_of_stages,
        outer_gear_bearing_number: this.uForm.value.outer_gear_bearing_number,
        pinion_bearing_number: this.uForm.value.pinion_bearing_number,
        pinion_gear_teeth: this.uForm.value.pinion_gear_teeth,
        pinion_gear_rpm: this.uForm.value.pinion_gear_rpm,
        outer_gear_number: this.uForm.value.outer_gear_number,
        outer_teeth: this.uForm.value.outer_teeth,
        outer_bearing_no: this.uForm.value.outer_bearing_no,
        gmf_data: this.uForm.value.gmf_data,
        deb_pinion_number: this.uForm.value.deb_pinion_number || "NA",
        ndeb_pinion_number: this.uForm.value.ndeb_pinion_number || "NA",
        belt_length: this.uForm.value.belt_length,
        belt_number: this.uForm.value.belt_number,
        db_shart_centers: this.uForm.value.db_shart_centers,
        driven_pulley_diameter: this.uForm.value.driven_pulley_diameter,
        driver_pulley_diameter: this.uForm.value.driver_pulley_diameter,
        drive_type: this.driveType,
        no_of_blades: this.uForm.value.no_of_blades,
        device_config_update_interval:
          this.uForm.value.device_config_update_interval,
        vs_scan_rate: this.uForm.value.vs_scan_rate,
        machine_threshold: this.uForm.value.machine_threshold_status,
        vs_resolution_mode: this.uForm.value.vs_resolution_mode,
        machine_threshold_status: this.uForm.value.machine_threshold_status,
        accelero_FS: this.uForm.value.accelero_FS,
        sensor_mounting_axis_option:
          this.uForm.value.sensor_mounting_axis_option,
        rtd_one: this.uForm.value.rtd_one,
        rtd_two: this.uForm.value.rtd_two,
        rtd_three: this.uForm.value.rtd_three,
        audible_adjustment: this.uForm.value.audible_adjustment,
        poles: this.uForm.value.polePairNumber,
        dctype: this.uForm.value.dc_type,
        subsystem_id : this.fromboiler === 'boiler'? this.subsystemId : null,
      };
      if (_imgId != null) {
        body["image_id"] = _imgId;
      }
      if (this.fromDataArray.length === 0) {
        body["asset_selector"] = "MASTER"; //"primary";
        this.fromDataArray.push({ body: {...body, orientation: this.assetOrientation}, sensor: this.sensorDetails });
        // console.log("fromDataArrayMaster", this.fromDataArray);
      } else {
        body["asset_selector"] = "CHILD"; // "secondary";
        this.fromDataArray.push({ body: body, sensor: this.sensorDetails });
      }
      this.allDevices = this.allDevices.filter(
        (item) => item.mac_address !== this.uForm.value.mac_address
      );
      this.filterdOptions = this.filterdOptions.filter(
        (item) => item.mac_address !== this.uForm.value.mac_address
      );
      //
      this.variableRPMToggle='fixed';
      this.nextSensor(
        this.currentLbl,
        this.currentLbl + 1,
        -1,
        this.uForm.value.mac_address
      );
    }
  }

  calibratepopup() {
    const alertDialogRef = this.dialog.open(
      DialogOverviewExampleDialogComponent,
      {
        width: "100%g",
        maxWidth: "730px",
        disableClose: false,
        data: {
          type: "VibratioCallibrate",
          assetid: this.assetid,
          deviceid: this.deviceid,
          macadress: this.connectedMacAddress,
          configtime: this.uForm.value.data_frequency,
          devicestatus: this.assetStatus,
        },
      }
    );
  }
  saveAsstes() {
    if (this.showEditUsertxt === "Create Asset") {
      this.showDisabledSaveBtn = true;
      this.showEnabledSaveBtn = false;
      this.changeService.loader(true);
      this.spinner.show();
      this.saveDraft();
      let body = this.fromDataArray[0]["body"];
      let objBody = {
        site_id: body.site_id,
        application_id: body.application_id,
        client_id: body.user_id,
        device_type: body.device_type_id,
        group_id: body.asset_batch_id,
        status: "PENDING",
        template: JSON.stringify(this.parentModel),
      };

      this.service
        .postTemplate(this.addAssetsUrl + "/v2/addtemplate", objBody)
        .then((resQuery) => {
          for (let s = 0; s < this.fromDataArray.length; s++) {
            this.service
              .postData(this.addAssetsUrl, this.fromDataArray[s]["body"])
              .then((res) => {
                if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
                  this.spinner.hide();
                  this.showDisabledSaveBtn = false;
                  this.showEnabledSaveBtn = true;
                  this.changeService.loader(false);
                  const msgErr = JSON.parse(JSON.stringify(res)).data.body
                    .message;
                  this.service.showError(msgErr);
                } else if (
                  JSON.parse(JSON.stringify(res)).data.status === "success"
                ) {
                  if (s === this.fromDataArray.length - 1) {
                    this.spinner.hide();
                    this.showDisabledSaveBtn = false;
                    this.showEnabledSaveBtn = true;
                    this.changeService.loader(false);
                    this.changeService.loader(false);
                    this.assetsID = JSON.parse(
                      JSON.stringify(res)
                    ).data.asset_id;
                    this.uploader.uploadAll();
                    this.uploader.onProgressItem = (progress: any) => {
                      this.percentDone = progress["progress"];
                      this.pic = true;
                    };
                    this.service.showSuccess("Assets registered successfully");
                    if(this.fromboiler === 'boiler'){
                      const navigationExtras = {
                        skipLocationChange :true,
                          queryParams:{
                            subsystem_id:this.subsystemId,
                            boilerName: this.boilerName,
                            application_name: this.boiler_application_name,
                            site_name: this.boiler_site_name
                          }
                        }
                      this.router.navigate(["/boiler-configurator"],navigationExtras);
                    }else{
                      this.router.navigate(["/device-reports"]);
                    }


                    // console.log("gear box create")
                  }
                } else {
                  this.spinner.hide();
                  this.showDisabledSaveBtn = false;
                  this.showEnabledSaveBtn = true;
                  this.changeService.loader(false);
                  this.service.showError("Something went wrong.");
                }
              });
          }
        });
    } else {
      if (this.uForm.value.rated_power != this.ratedPower) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.vs_scan_rate != this.scanRateValue) {
        this.callMqttEnable = true;
      }
      if (
        this.uForm.value.machine_threshold_status != this.machinethresholdvalue
      ) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.wifi_user != this.ssidUser) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.wifi_password != this.passwordSsid) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.data_frequency != this.datafreq) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.accelro_odr != this.odrValue) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.accelro_odr_high != this.odrValueHigh) {
        this.callMqttEnable = true;
      }
      if (
        this.uForm.value.cloud_pushrate_anomaly != this.cloudPushRateAnomaly
      ) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.cloud_anomaly_counter != this.cloudAnomalyCounter) {
        this.callMqttEnable = true;
      }
      if (this.uForm.value.cloud_pushrate_high != this.cloudPushrateHigh) {
        this.callMqttEnable = true;
      }
      if ((this.uForm.value.cloud_pushrate_anomaly) < 1) {
        return this.service.showError(
          "Cloud push rate anomaly value can't be less than 1."
        );
      }
      if (
        (this.uForm.value.cloud_pushrate_high) <
        (this.uForm.value.data_frequency)
      ) {
        return this.service.showError(
          "Cloud push rate high must be greater than sensor data publish frequency."
        );
      }

      const body = {
        mac_address: this.uForm.value.mac_address,
        line_current: this.uForm.value.line_current,
        previous_inventory_id: this.existedInventoryID,
        user_id: this.userID,
        axial: this.uForm.value.Axial,
        radial: this.uForm.value.Vertical,
        tangential: this.uForm.value.Horizontal,
        device_sno: this.currentFormCount,
        template_id: this.assetTemplateID,
        device_name: this.uForm.value.device_name,
        admin_id: this.adminID,
        accelro_odr: this.uForm.value.accelro_odr,
        accelro_odr_high: this.uForm.value.accelro_odr_high,
        mqttcheckstatus: this.callMqttEnable,
        asset_on_off_status: this.onOffStatus,
        device_type_id: this.deviceTypeID,
        motor_make: this.uForm.value.motor_make,
        equipment_location: this.uForm.value.equipment_location,
        cloud_pushrate_high: this.uForm.getRawValue().cloud_pushrate_high,
        cloud_pushrate_anomaly: this.uForm.getRawValue().cloud_pushrate_anomaly,
        cloud_anomaly_counter: this.uForm.getRawValue().cloud_anomaly_counter,
        insulation_class: this.uForm.value.insulation_class,
        asset_type: this.selectedAssetType,
        subtype: this.subAssetType,
        frame: this.uForm.value.frame,
        frame_unit: "L",
        rated_ambient_temprature: this.uForm.value.rated_ambient_temprature,
        rated_ambient_temprature_unit: this.uForm.value.temperature_sy,
        power_factor: this.uForm.value.power_factor,
        rated_power: this.uForm.value.rated_power,
        rated_power_unit: this.uForm.value.power_unit,

        rated_rpm: this.uForm.value.rated_rpm,
        max_rated_rpm:
          this.variableRPMToggle === "fixed"
            ? 0
            : this.uForm.value.max_rated_rpm,
        min_rated_rpm:
          this.variableRPMToggle === "fixed"
            ? this.uForm.value.rated_rpm
            : this.uForm.value.min_rated_rpm,
        rpm_toggle: this.uForm.value.rpm_toggle,
        percentage_efficiency: this.uForm.value.percentage_efficiency,
        rated_voltage: this.uForm.value.rated_voltage,
        motor_serial_no: this.uForm.value.motor_serial,
        line_frequency: this.uForm.value.line_frequency,
        duty: this.uForm.value.duty,
        inventory_id: this.InventoryIDValue,
        site_id:
          this.uForm.value.site_id === undefined
            ? this.siteID
            : this.uForm.value.site_id,
        application_id:
          this.uForm.value.application_id === undefined
            ? this.applicationNewID
            : this.uForm.value.application_id,
        data_frequency: this.uForm.getRawValue().data_frequency,
        config_pull_rate: this.uForm.value.config_pull_rate,
        cloud_push_rate: this.uForm.value.cloud_push_rate,
        sensor_scan_rate: this.uForm.value.sensor_scan_rate,
        file_comparison_threshold_percentage:
          this.uForm.value.file_comparison_threshold_percentage,
        winding_rtd: this.uForm.value.winding_rtd,
        wifi_user: this.uForm.value.wifi_user,
        wifi_password: this.uForm.value.wifi_password,
        connectivity_type: this.uForm.value.connectivity_type,
        ip: this.uForm.value.ip,
        port: this.uForm.value.port,
        proxy_username: this.uForm.value.proxy_username,
        proxy_password: this.uForm.value.proxy_password,
        name:
          this.uForm.value.name === undefined
            ? this.assetName
            : this.uForm.value.name,
        de_bearing_number: this.uForm.value.de_bearing_number || "NA",
        nde_bearing_number: this.uForm.value.nde_bearing_number || "NA",
        nde_bearing: this.uForm.value.nde_bearing,
        de_bearing: this.uForm.value.de_bearing,
        belt_length: this.uForm.value.belt_length,
        belt_number: this.uForm.value.belt_number,
        db_shart_centers: this.uForm.value.db_shart_centers,
        driven_pulley_diameter: this.uForm.value.driven_pulley_diameter,
        driver_pulley_diameter: this.uForm.value.driver_pulley_diameter,
        drive_type: this.driveType,
        no_of_blades: this.uForm.value.no_of_blades,
        gear_make: this.uForm.value.gear_make,
        gear_type_one: this.uForm.value.gear_one,
        gear_type_two: this.uForm.value.gear_two,
        outer_gear_rpm: this.uForm.value.outer_gear_rpm,
        number_of_stages: this.uForm.value.number_of_stages,
        outer_gear_bearing_number: this.uForm.value.outer_gear_bearing_number,
        pinion_bearing_number: this.uForm.value.pinion_bearing_number,
        pinion_gear_teeth: this.uForm.value.pinion_gear_teeth,
        pinion_gear_rpm: this.uForm.value.pinion_gear_rpm,
        outer_gear_number: this.uForm.value.outer_gear_number,
        outer_teeth: this.uForm.value.outer_teeth,
        outer_bearing_no: this.uForm.value.outer_bearing_no,
        gmf_data: this.uForm.value.gmf_data,
        deb_pinion_number: this.uForm.value.deb_pinion_number || "NA",
        ndeb_pinion_number: this.uForm.value.ndeb_pinion_number || "NA",
        device_config_update_interval:
          this.uForm.value.device_config_update_interval,
        vs_scan_rate: this.uForm.value.vs_scan_rate,
        machine_threshold_status: this.uForm.value.machine_threshold_status,
        accelero_FS: this.uForm.value.accelero_FS,
        vs_resolution_mode: this.uForm.value.vs_resolution_mode,

        sensor_mounting_axis_option:
          this.uForm.value.sensor_mounting_axis_option,
        rtd_one: this.uForm.value.rtd_one,
        rtd_two: this.uForm.value.rtd_two,
        rtd_three: this.uForm.value.rtd_three,
        audible_adjustment: this.uForm.value.audible_adjustment,
        poles: this.uForm.value.polePairNumber,
        dctype: this.uForm.value.dc_type,
        orientation: this.assetOrientation
      };
      // console.log(this.uForm.value, "de_bearing_number");
      this.showDisabledUpdateBtn = true;
      this.showEnableUpdateBtn = false;
      this.changeService.loader(true);
      if (this.isEmpty(this.getDirtyValues(this.uForm))) {
        this.auditTrail(body);
        this.service
          .putData(
            this.updateAssetsUrl +
              "/" +
              this.assetsID +
              "?asset_type=" +
              this.selectedAssetType,
            body
          )
          .then((res) => {
            this.showDisabledUpdateBtn = false;
            this.showEnableUpdateBtn = true;
            this.changeService.loader(false);
            if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
              const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
              this.service.showError(msgErr);
            } else if (
              JSON.parse(JSON.stringify(res)).data.status === "success"
            ) {
              this.service.showSuccess("Asset updated successfully");
              if (this.stateRef === "FROM_LIST") {
                this.router.navigate(["device-reports"]);
              } else {
                this.goToDetailScreen();
              }
            }
          });
      } else if (!this.isEmpty(this.getDirtyValues(this.uForm))) {
        this.auditTrail(body);
        this.service
          .putData(
            this.updateAssetsUrl +
              "/" +
              this.assetsID +
              "?asset_type=" +
              this.selectedAssetType,
            body
          )
          .then((res) => {
            this.showDisabledUpdateBtn = false;
            this.showEnableUpdateBtn = true;
            this.changeService.loader(false);
            // console.log(res,"resssssssss");
            if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
              const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
              this.service.showError(msgErr);
            } else if (
              JSON.parse(JSON.stringify(res)).data.status === "success"
            ) {
              this.service.showSuccess("Asset updated successfully");
              if (this.stateRef === "FROM_LIST") {
                this.router.navigate(["device-reports"]);
              } else {
                this.goToDetailScreen();
              }
              if (
                (this.assetStatus === 1 || this.assetStatus === 0) &&
                this.callMqttEnable === true
              ) {
                this.service
                  .getDataWithQuery(
                    this.deviceStatusURL +
                      "inventory/v2/config/" +
                      this.connectedMacAddress
                  )
                  .then((res) => {
                    let response = JSON.parse(JSON.stringify(res)).data;
                  });
              }
            } else {
              this.service.showError("Something went wrong.");
            }
          });
      } else {
        this.service.showError("No changes detected.");
      }
    }
  }

  auditTrail(body) {
    let newob = this.getDirtyValues(this.uForm);
    let oldobj = this.olddata;
    let obj_keys = Object.keys(newob);
    let newObject = {};
    obj_keys.forEach((key) => {
      (newObject[`old_${key}`] = oldobj[key]),
        (newObject[`${key}`] = newob[key]);
    });
    let payload = {
      client: localStorage.getItem("user_name"),
      site: this.atSiteName,
      application: this.atApplicationName,
      mac_address: this.connectedMacAddress,
      serial_number: this.serialNumber,
      by_user: localStorage.getItem("user_id"),
      belong_to:
        localStorage.getItem("associated_clientid") === "null"
          ? localStorage.getItem("user_id")
          : localStorage.getItem("associated_clientid"),
      module: "EDIT ASSET",
      updated_obj: JSON.stringify(newObject),
    };
    if (localStorage.getItem("role") === "CLIENT") {
      payload["belong_to"] = JSON.parse(localStorage.getItem("user_id"));
    } else if (localStorage.getItem("role") === "ACCOUNT_MANAGER") {
      payload["belong_to"] = JSON.parse(
        localStorage.getItem("admin_client_id")
      );
    }
    this.service
      .postData(this.middleware_url + "v1/audit/trail", payload)
      .then((res) => {});
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  onAssetChangeValue(selection, val) {
    this.selectedAssetType = selection;
    // if (val === 'click_event') {
    //   this.cancelRadioPress(selection);
    // } else {
    switch (this.selectedAssetType) {
      case "MOTOR":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "GEAR":
        this.assetDetailForm = false;
        this.gearDetailForm = true;
        this.gearFormController();
        break;
      case "FAN_BLOWER":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "PUMP":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "COMPRESSOR":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "JOURNAL_BEARING":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
    }
    //}
  }
  cancelRadioPress(value) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "400px",
      height: "auto",
      data: {
        type: "discard-changes-radio",
        typeOf: "asset",
        cat: this.tempValue,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.tempValue = this.selectedAssetType;
        this.selectNumberOfAssets(1);
        if (value === "MOTOR") {
          this.assetDetailForm = true;
          this.gearDetailForm = false;
          // this.ngOnInit();
        } else if (value === "GEAR") {
          this.assetDetailForm = false;
          this.gearDetailForm = true;
          // this.gearFormController();
        } else if (value === "FAN_BLOWER") {
          this.assetDetailForm = true;
          this.gearDetailForm = false;
          // this.ngOnInit();
        } else if (value === "PUMP") {
          this.assetDetailForm = true;
          this.gearDetailForm = false;
          // this.ngOnInit();
        } else if (value === "COMPRESSOR") {
          this.assetDetailForm = true;
          this.gearDetailForm = false;
          // this.ngOnInit();
        } else if (value === "JOURNAL_BEARING") {
          this.assetDetailForm = true;
          this.gearDetailForm = false;
          // this.ngOnInit();
        }
      } else {
        this.selectedAssetType = this.tempValue;
      }
    });
  }

  public onDriveChange(selectedValue) {
    if (selectedValue.value != undefined) {
      this.driveType = selectedValue.value;
    } else {
      this.driveType = selectedValue;
    }
    if (this.driveType === "PULLEY") {
      this.driveVisibility = true;
      this.uForm.get("belt_length").setValidators([Validators.required]);
      this.uForm.get("belt_number").setValidators([Validators.required]);
      this.uForm.get("db_shart_centers").setValidators([Validators.required]);
      this.uForm
        .get("driven_pulley_diameter")
        .setValidators([Validators.required]);
      this.uForm
        .get("driver_pulley_diameter")
        .setValidators([Validators.required]);
    } else {
      this.driveVisibility = false;
      this.uForm.get("belt_length") === null
        ? ""
        : this.uForm.get("belt_length").clearValidators();
      //this.uForm.get("belt_length").clearValidators();
      this.uForm.get("belt_number") === null
        ? ""
        : this.uForm.get("belt_number").clearValidators();
      this.uForm.get("db_shart_centers") === null
        ? ""
        : this.uForm.get("db_shart_centers").clearValidators();
      this.uForm.get("driven_pulley_diameter") === null
        ? ""
        : this.uForm.get("driven_pulley_diameter").clearValidators();
      this.uForm.get("driver_pulley_diameter") === null
        ? ""
        : this.uForm.get("driver_pulley_diameter").clearValidators();
      //this.deletePulleyInfo();
    }
  }

  togglemyPasswordFieldType() {
    this.isTextFieldType = !this.isTextFieldType;
  }

  deletePulleyInfo() {
    if (this.showEditUsertxt !== "Create Asset") {
      this.service
        .deleteInfo(`${this.updateAssetsUrl}/device/${this.assetsID}`)
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.message === "deleted") {
          }
        });
    }
  }

  selectBeltNumber(ev) {
    let obj = this.beltData.filter((x) => x.belt_number === ev);
    this.beltLength = obj[0].belt_length;
    this.uForm.controls["belt_length"].setValue(this.beltLength);
  }

  public gearFormController() {
    this.uForm = this.formBuilder.group({
      motor_make: new FormControl(""),
      equipment_location: new FormControl(""),
      cloud_pushrate_high: new FormControl(60, [Validators.required]),
      cloud_pushrate_anomaly: new FormControl(180, [Validators.required]),
      cloud_anomaly_counter: new FormControl(1, [Validators.required]),
      accelro_odr_high: new FormControl("NORMAL"),
      accelro_odr: new FormControl("NORMAL"),
      frame: new FormControl(""),
      line_current: new FormControl("0"),
      rated_ambient_temprature: new FormControl("0"),
      insulation_class: new FormControl(""),
      motor_serial: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      rated_power: new FormControl("", Validators.required),
      rated_rpm: new FormControl(""),
      max_rated_rpm: new FormControl(""),
      device_name: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      min_rated_rpm: new FormControl(""),
      rated_voltage: new FormControl(""),
      power_factor: new FormControl(""),
      temperature_sy: new FormControl(""),
      power_unit: new FormControl("KW"),
      rpm_toggle: new FormControl("fixed"),
      site_id: new FormControl("", Validators.required),
      application_id: new FormControl("", Validators.required),
      mac_address: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      duty: new FormControl(""),
      device_config_update_interval: new FormControl(60),
      vs_scan_rate: new FormControl(15, Validators.required),
      machine_threshold_status: new FormControl(0.5, [Validators.required]),
      accelero_FS: new FormControl(8, [Validators.required]),
      vs_resolution_mode: new FormControl("NORMAL"),

      sensor_mounting_axis_option: new FormControl("PARALLEL_SIDE"),
      rtd_one: new FormControl("MS"),
      rtd_two: new FormControl("DE"),
      rtd_three: new FormControl("NDE"),
      percentage_efficiency: new FormControl(""),
      // line_frequency: new FormControl("", [Validators.required]),
      data_frequency: new FormControl(15, [Validators.required]),
      config_pull_rate: new FormControl(60),
      cloud_push_rate: new FormControl(60),
      sensor_scan_rate: new FormControl(15),
      file_comparison_threshold_percentage: new FormControl(60),
      winding_rtd: new FormControl("0"),
      connectivity_type: new FormControl("wifi"),
      wifi_user: new FormControl("EnerticsWiFi", [Validators.required]),
      wifi_password: new FormControl("Enertics"),
      ip: new FormControl(""),
      port: new FormControl(""),
      proxy_username: new FormControl(""),
      proxy_password: new FormControl(""),
      name: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      de_bearing_number: new FormControl({ value: "NA", disabled: true }),
      nde_bearing_number: new FormControl({ value: "NA", disabled: true }),
      nde_bearing: new FormControl("0"),
      de_bearing: new FormControl("0"),
      gear_make: new FormControl(""),
      gear_type_one: new FormControl(""),
      gear_type_two: new FormControl(""),
      outer_gear_rpm: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      number_of_stages: new FormControl(""),
      outer_gear_bearing_number: new FormControl(""),
      pinion_gear_teeth: new FormControl(""),
      pinion_gear_rpm: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      outer_gear_number: new FormControl(""),
      outer_teeth: new FormControl(""),
      outer_bearing_no: this.formBuilder.array([]),
      deb_pinion_number: new FormControl("NA", Validators.required),
      ndeb_pinion_number: new FormControl("NA", Validators.required),
      gear_count: new FormControl(1, Validators.required),
      gmf_data: this.formBuilder.array([]),
      GMF_unit: new FormControl("no"),
      GMFdrop: new FormControl(Validators.required),
      no_of_blades: new FormControl(0),
      bearing_radio: new FormControl("off"),
      output_bearing_radio: new FormControl("no"),
      audible_adjustment: new FormControl([0]),
      polePairNumber: new FormControl([0]),
      dc_type: new FormControl(""),
    });
    //On creating asset gear form select sleeve bearing and diabled both dropdowns
    this.uForm.get("deb_pinion_number").disable();
    this.uForm.get("ndeb_pinion_number").disable();

    if (this.showEditUsertxt === "Create Asset") {
      this.outer_bearing_no().push(
        this.formBuilder.group({
          ndeb_outer: new FormControl(
            { value: "NA", disabled: true },
            Validators.required
          ),
          deb_outer: new FormControl(
            { value: "NA", disabled: true },
            Validators.required
          ),
        })
      );
    }
  }

  addDevice() {
    this.router.navigate(["clients-add-assets"]);
  }

  onSsidKey(value) {}

  onPasswordKey(value) {}

  selectConnectionType(value: string) {
    switch (value) {
      case "wifi":
        this.connectionInput = true;
        this.connectionInputProxy = false;
        this.uForm.get("ip").setValidators();
        this.uForm.get("port").setValidators();
        break;
      case "bluetooth":
        this.connectionInput = false;
        this.connectionInputProxy = false;
        this.uForm.get("ip").setValidators();
        this.uForm.get("port").setValidators();
        break;
      case "cellular":
        this.connectionInput = false;
        this.connectionInputProxy = false;
        this.uForm.get("ip").setValidators();
        this.uForm.get("port").setValidators();
        break;
      case "proxy":
        this.connectionInputProxy = true;
        this.connectionInput = false;
        this.uForm.get("ip").setValidators([Validators.required]);
        this.uForm.get("port").setValidators([Validators.required]);
        break;
    }
  }

  async goToDetailScreen() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "",
        deviceId: this.deviceid,
        assetid: this.assetid,
        label: this.label,
        asset_type: this.assetType,
        sub_type: this.subAssetType,
        device_serial_no: this.device_sno,
        serial_no: this.device_sno,
        assetStatus: this.assetStatus,
        sensorType: this.sensorType,
        no_of_children: this.noofchildren,
        userid: this.userID,
        asset_master_info: JSON.stringify(this.device),
        macaddress: this.connectedMacAddress,
        overallStatus:this.overallStatus,
        overall_powertrain_status_edit:this.overall_powertrain_status
      },
    };

    this.router.navigate(["detail-nxt"], navigationExtras);
  }

  saveDevice() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: this.pid,
      },
    };
    this.router.navigate(["device-reports"], navigationExtras);
  }

  outer_bearing_no(): FormArray {
    return this.uForm.get("outer_bearing_no") as FormArray;
  }
  gmf_data(): FormArray {
    return this.uForm.get("gmf_data") as FormArray;
  }
  editgroup_name(first, second, id): FormGroup {
    // console.log("first"+first+"second"+second+"id"+id);
    return this.formBuilder.group({
      ndeb_outer: new FormControl(first, [Validators.required]),
      deb_outer: new FormControl(second, [Validators.required]),
      id: new FormControl(id),
      gear_type:"OUTER"
    });
  }
  editgroup_gmfname(gmfname, gmfnumber): FormGroup {
    {
      return this.formBuilder.group({
        gmfName: new FormControl(gmfname, [Validators.required]),
        gmfNumber: new FormControl(gmfnumber, [Validators.required]),
      });
    }
  }
  newgroup_name(): FormGroup {
    return this.formBuilder.group({
      ndeb_outer: new FormControl("", Validators.required),
      deb_outer: new FormControl("", Validators.required),
    });
  }
  newgroup_GMFname(): FormGroup {
    return this.formBuilder.group({
      gmfName: new FormControl("", [Validators.required]),
      gmfNumber: new FormControl("", [Validators.required]),
    });
  }
  selectNumberOfGear(event: any) {
    //console.log(event);
    let addFields =
      parseInt(event) - parseInt(this.outer_bearing_no().value.length);
    if (this.showEditUsertxt === "Create Asset") {
      //console.log("yes");
      if (parseInt(event) !== 0) {
        for (var n = 0; n < addFields; n++) {
          this.outer_bearing_no().push(this.newgroup_name());
        }
        this.uForm.controls["gear_count"].setValue(
          this.outer_bearing_no().value.length
        );
        if (this.outer_bearing_no().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["gear_count"].setValue(
            this.outer_bearing_no().value.length
          );
        }
      } else {
        this.uForm.controls["gear_count"].setValue(1);
      }
    } else {
      if (parseInt(event) !== 0) {
        if (this.outer_bearing_no().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["gear_count"].setValue(
            this.outer_bearing_no().value.length
          );
        } else {
          for (let n = 0; n < addFields; n++) {
            this.outer_bearing_no().push(this.newgroup_name());
          }
        }
      } else {
        this.uForm.controls["gear_count"].setValue(1);
      }
    }
  }
  //gmf

  selectGMF(val: any) {
    if (val == "yes") {
      this.GMFvisible = true;
    } else {
      this.GMFvisible = false;
    }
  }
  selectNumberOfGMF(event: any) {
    let addinput = [];
    let addFields = parseInt(event) - parseInt(this.gmf_data().value.length);
    if (this.showEditUsertxt === "Create Asset") {
      if (parseInt(event) !== 0) {
        for (let i = 0; i < addFields; i++) {
          this.gmf_data().push(this.newgroup_GMFname());
        }
        this.uForm.controls["GMFdrop"].setValue(this.gmf_data().value.length);
        if (this.gmf_data().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["GMFdrop"].setValue(this.gmf_data().value.length);
        }
      } else {
        this.uForm.controls["GMFdrop"].setValue(1);
      }
    } else {
      if (parseInt(event) !== 0) {
        if (this.gmf_data().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["GMFdrop"].setValue(this.gmf_data().value.length);
        } else {
          for (let n = 0; n < addFields; n++) {
            this.gmf_data().push(this.newgroup_GMFname());
          }
        }
      } else {
        this.uForm.controls["GMFdrop"].setValue(1);
      }
    }
  }
  //gmf end
  clearFormArray() {
    while (this.outer_bearing_no().length !== 0) {
      this.outer_bearing_no().removeAt(0);
    }
  }

  removeFileds(index, val) {
    if (this.showEditUsertxt !== "Create Asset") {
      if (val == "gmf") {
        for (let i = 0; i < this.gmf_data().value.length; i++) {
          if (this.gmf_data().value[i] === undefined) {
            if (i === index) {
              this.gmf_data().removeAt(index);
              this.uForm.controls["GMFdrop"].setValue(
                this.gmf_data().value.length
              );
            }
          } else {
            if (i === index) {
              this.service.showSuccess("deleted successfully");
              this.gmf_data().removeAt(index);
              this.uForm.controls["GMFdrop"].setValue(
                this.gmf_data().value.length
              );
            }
          }
        }
      } else {
        for (let n = 0; n < this.outer_bearing_no().value.length; n++) {
          if (this.outer_bearing_no().value[n].id === undefined) {
            if (n === index) {
              this.outer_bearing_no().removeAt(index);
              this.uForm.controls["gear_count"].setValue(
                this.outer_bearing_no().value.length
              );
            }
          } else {
            if (n === index) {
              this.service
                .deleteInfo(
                  this.updateAssetsUrl +
                    "/outer/remove/" +
                    this.outer_bearing_no().value[index].id
                )
                .then((res) => {
                  if (
                    JSON.parse(JSON.stringify(res)).data.message === "deleted"
                  ) {
                    this.service.showSuccess("deleted successfully");
                    this.outer_bearing_no().removeAt(index);
                    this.uForm.controls["gear_count"].setValue(
                      this.outer_bearing_no().value.length
                    );
                  }
                });
            }
          }
        }
      }
    } else {
      if (val == "gmf") {
        this.gmf_data().removeAt(index);
        this.uForm.controls["GMFdrop"].setValue(index);
      } else {
        this.outer_bearing_no().removeAt(index);
        this.uForm.controls["gear_count"].setValue(
          this.outer_bearing_no().value.length
        );
      }
    }
  }

  cancelButtonPress() {
    if (this.showEditUsertxt === "Create Asset") {
      if(this.fromboiler === 'boiler'){
        const navigationExtras = {
          skipLocationChange : true,
          queryParams:{
            subsystem_id:this.subsystemId,
            boilerName: this.boilerName,
            application_name: this.boiler_application_name,
            site_name: this.boiler_site_name
          }
        }
        this.router.navigate(["/boiler-configurator"], navigationExtras);
      }else{
        const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
          width: "400px",
          height: "auto",
          data: {
            type: "discard-changes-dialog-box",
            typeOf: "asset",
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result !== undefined) {
            this.router.navigate(["device-reports"]);
          }
        });
      }
    } else {
      if (this.stateRef === "FROM_LIST") {
        this.router.navigate(["device-reports"]);
      } else {
        this.goToDetailScreen();
      }
    }
  }

  onAssetNameChange(assetName: string) {}

  getDirtyValues(form: any) {
    let dirtyValues = {};
    Object.keys(form.controls).forEach((key) => {
      let currentControl = form.controls[key];
      if (currentControl.dirty) {
        if (currentControl.controls)
          dirtyValues[key] = this.getDirtyValues(currentControl);
        else dirtyValues[key] = currentControl.value;
      }
    });
    return dirtyValues;
  }

  resetValues() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "300px",
      data: {
        type: "ResetValues",
        message: "Are you sure you want to reset the values?",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        // Reset form values
        this.uForm.controls["Axial"].setValue(1);
        this.uForm.controls["Vertical"].setValue(1);
        this.uForm.controls["Horizontal"].setValue(1);

        // Prepare the data for the API call
        const assetId = this.assetid; // Assuming assetid is available
        const deviceId = this.deviceid; // Assuming deviceid is available
        const url = `${this.middleware_url}/resetCal/${assetId}/${deviceId}`;

        // Make the API call
        this.service
          .getData(url)
          .then((response) => {
            // Handle the response here
          })
          .catch((error) => {
            // Handle errors here
            console.error("Error during reset:", error);
          });
      }
    });
  }

}
